const navigation = {
  'navigation.section.collect': '收集',
  'navigation.section.process': '处理',
  'navigation.section.create': '创作',
  'navigation.section.short_drama': '短剧',
  'navigation.section.ai_employees': 'AI员工',
  'navigation.section.capabilities': '能力',
  'navigation.section.manage': '管理',
  'navigation.item.sources': '笔记来源',
  'navigation.item.materials': '资源库',
  'navigation.item.desktop_materials': '本地资源库',
  'navigation.item.notebooks': '笔记本',
  'navigation.item.search': '提问与搜索',
  'navigation.item.ecommerce': '电商商品',
  'navigation.item.midjourney_v7': 'MidJourney V7',

  'navigation.item.bananapro': 'Nano Banana Pro',
  'navigation.item.video_generator': '视频生成',
  'navigation.item.comfyui_workflow': 'ComfyUI 工作流',
  'navigation.item.short_drama_projects': '短剧项目库',
  'navigation.item.short_drama_assets': '短剧资产库',
  'navigation.item.short_drama_prompts': '提示词模板',
  'navigation.item.creation_prompts': '提示词模板',
  'navigation.item.digital_employees': '手机员工',
  'navigation.item.browser_employees': '浏览器员工',
  'navigation.item.agents': '智能体',
  'navigation.item.plugins': '插件',
  'navigation.item.pc_employees': 'PC员工',
  'navigation.item.projects': '项目',
  'navigation.item.marketplace': '应用市场',
  'navigation.item.fishown': 'FishOwn',
  'navigation.item.skills': '插件与技能',
  'navigation.item.workflows': '工作流',
  'navigation.item.cron': '定时任务',
  'navigation.item.models': '模型',
  'navigation.item.organization': '组织',
    'navigation.item.settings': '设置',
  'navigation.item.advanced': '高级',
  'navigation.item.task_monitor': '任务监控',
  'navigation.item.member_center': '会员中心',
  'navigation.create': '新建',
  'navigation.create.digital_employees': '手机员工',
  'navigation.create.source': '数据源',
  'navigation.create.notebook': '笔记本',
  'navigation.create.image_generator': '图片生成',
  'navigation.create.tooltip': '新建',
  'navigation.backToNotebook': '返回笔记本',
  'navigation.backToSources': '返回数据源',
}

const controls = {
  'controls.theme': '主题',
  'controls.quickActions': '快捷操作',
  'controls.quickActionsHint': '导航、搜索、提问、主题',
  'controls.signOut': '退出登录',
}

const user = {
  'user.menuTitle': '用户',
  'user.systemLabel': '系统',
  'user.systemTooltip': '当前租户：{system}',
  'user.systemUnknown': '未知系统',
  'user.tenantUnknown': '未知租户',
  'user.spaceUnknown': '未知空间',
  'user.spaceLabel': '空间',
  'user.roleLabel': '角色',
  'user.switchTenant': '切换租户',
  'user.role.owner': '所有者',
  'user.role.admin': '管理员',
  'user.role.employee': '员工',
  'user.role.unknown': '未知角色',
}

const settingsLanguage = {
  'settings.title': '设置',
  'settings.language.title': '界面语言',
  'settings.language.description': '选择控制台界面的显示语言',
  'settings.language.note': '切换后导航与常用控件立即更新。',
  'settings.language.en': 'English',
  'settings.language.zh': '中文',
}

const settingsActions = {
  'settings.actions.save': '保存设置',
  'settings.actions.saving': '保存中...',
}

const settingsCommon = {
  'settings.common.helpMeChoose': '帮我选择',
  'settings.load.errorTitle': '加载设置失败',
  'settings.load.errorUnexpected': '发生未知错误。',
  'common.all': '全部',
}

const settingsContentProcessing = {
  'settings.content.title': '内容处理',
  'settings.content.description': '配置文档与链接的处理方式',
  'settings.content.doc.label': '文档处理引擎',
  'settings.content.doc.placeholder': '选择文档处理引擎',
  'settings.content.doc.option.auto': '自动（推荐）',
  'settings.content.doc.option.docling': 'Docling',
  'settings.content.doc.option.simple': '简单模式',
  'settings.content.doc.help.docling': 'Docling 略慢但更精准，特别适合包含表格或图片的文档。',
  'settings.content.doc.help.simple': '简单模式会直接提取文本，不做格式化，适合简单文档，复杂文档可能会丢失质量。',
  'settings.content.doc.help.auto': '自动（推荐）会优先尝试 Docling，失败时回退到简单模式。',
  'settings.content.url.label': '链接处理引擎',
  'settings.content.url.placeholder': '选择链接处理引擎',
  'settings.content.url.option.auto': '自动（推荐）',
  'settings.content.url.option.firecrawl': 'Firecrawl',
  'settings.content.url.option.jina': 'Jina',
  'settings.content.url.option.simple': '简单模式',
  'settings.content.url.help.firecrawl': 'Firecrawl 功能强大，需付费但有免费额度。',
  'settings.content.url.help.jina': 'Jina 也是不错的选择，并提供免费额度。',
  'settings.content.url.help.simple': '简单模式使用基础 HTTP 抓取，对依赖 JavaScript 的站点可能遗漏内容。',
  'settings.content.url.help.auto':
    '自动（推荐）会优先尝试 Firecrawl（如果 API Key 存在），然后使用 Jina 直到达到限制（或者如果设置了 API Key 则继续使用 Jina）。当以上选项均不可用时，将回退到简单模式。',
}

const settingsEmbedding = {
  'settings.embedding.title': '向量与搜索',
  'settings.embedding.description': '配置搜索与向量化选项',
  'settings.embedding.label': '默认向量化选项',
  'settings.embedding.placeholder': '选择向量化策略',
  'settings.embedding.option.ask': '每次询问',
  'settings.embedding.option.always': '始终向量化',
  'settings.embedding.option.never': '不向量化',
  'settings.embedding.help.intro':
    '向量化有助于你和智能体更好地发现内容。如果你在本地运行向量模型（例如 Ollama），几乎没有成本，可直接全部向量化。使用在线服务时，只有在大批量处理（每天上百份）时需要关注成本。',
  'settings.embedding.help.always': '如果你使用本地模型或内容量不大，推荐选择“始终向量化”。',
  'settings.embedding.help.ask': '如果希望每次手动决定，选择“每次询问”。',
  'settings.embedding.help.never': '如果不关心向量搜索或没有向量服务，选择“不向量化”。',
  'settings.embedding.help.cost':
    '参考：OpenAI text-embedding-3-small 每百万 tokens 约 $0.02（约 30 篇地球词条）。Gemini API 的 Text Embedding 004 免费，速率 1500 请求/分钟。',
}

const settingsFiles = {
  'settings.files.title': '文件管理',
  'settings.files.description': '配置文件处理与存储策略',
  'settings.files.label': '自动删除文件',
  'settings.files.placeholder': '选择是否自动删除',
  'settings.files.option.yes': '是',
  'settings.files.option.no': '否',
  'settings.files.help.intro':
    '文件上传并处理完成后通常不再需要。大多数用户都应允许自动删除上传文件。只有当 Notebook 被当作主存储（并不推荐）时才需要保留。未来可能改为总是下载后删除。',
  'settings.files.help.yes': '推荐选择“是”，处理后自动删除上传文件。',
  'settings.files.help.no': '只有确实需要保留原文件时才选择“否”。',
}

const notebooksPage = {
  'notebooks.page.title': '笔记本',
  'notebooks.page.searchPlaceholder': '搜索笔记本...',
  'notebooks.page.create': '新建笔记本',
  'notebooks.page.activeTitle': '活跃笔记本',
  'notebooks.page.archivedTitle': '已归档笔记本',
  'notebooks.page.empty.searchActiveTitle': '没有符合搜索的笔记本',
  'notebooks.page.empty.searchActiveDescription': '尝试使用不同的笔记本名称。',
  'notebooks.page.empty.searchArchivedTitle': '没有符合搜索的已归档笔记本',
  'notebooks.page.empty.searchArchivedDescription': '调整搜索以找到已归档的笔记本。',
}

const notebooksList = {
  'notebooks.list.empty.title': '暂无笔记本',
  'notebooks.list.empty.description': '创建第一个笔记本来组织你的研究内容。',
}

const notebooksCard = {
  'notebooks.card.archived': '已归档',
  'notebooks.card.unarchive': '取消归档',
  'notebooks.card.archive': '归档',
  'notebooks.card.delete': '删除',
  'notebooks.card.noDescription': '暂无描述',
  'notebooks.card.updated': '更新于',
  'notebooks.card.confirm.title': '删除笔记本',
  'notebooks.card.confirm.description':
    '确定要删除 “{name}” 吗？此操作不可撤销，将删除所有来源、笔记和对话会话。',
  'notebooks.card.confirm.cta': '删除',
}

const notebooksHeader = {
  'notebooks.header.namePlaceholder': '笔记本名称',
  'notebooks.header.archivedBadge': '已归档',
  'notebooks.header.unarchive': '取消归档',
  'notebooks.header.archive': '归档',
  'notebooks.header.knowledgeGraph': '知识图谱',
  'notebooks.header.knowledgeGraphComingSoon': '暂不开放，敬请期待',
  'notebooks.header.delete': '删除',
  'notebooks.header.descriptionPlaceholder': '添加描述...',
  'notebooks.header.descriptionEmpty': '添加描述...',
  'notebooks.header.meta.created': '创建于',
  'notebooks.header.meta.updated': '更新于',
  'notebooks.header.confirm.title': '删除笔记本',
  'notebooks.header.confirm.description':
    '确定要删除 “{name}” 吗？此操作不可撤销，将删除所有来源、笔记和对话会话。',
  'notebooks.header.confirm.cta': '永久删除',
}

const notebooksDetail = {
  'notebooks.detail.notFoundTitle': '未找到笔记本',
  'notebooks.detail.notFoundDescription': '请求的笔记本不存在。',
  'notebooks.detail.tabs.sources': '来源',
  'notebooks.detail.tabs.notes': '笔记',
  'notebooks.detail.tabs.chat': '对话',
}

const notebooksKnowledgeGraph = {
  'notebooks.knowledgeGraph.title': '知识图谱',
  'notebooks.knowledgeGraph.description': '笔记本 {notebookId} 的知识图谱。',

  'notebooks.knowledgeGraph.status.initializing': '正在初始化...',
  'notebooks.knowledgeGraph.status.checkingIndex': '正在检查索引数据...',
  'notebooks.knowledgeGraph.status.loadingWindow': '正在加载图谱窗口...',
  'notebooks.knowledgeGraph.status.loadingJson': '正在加载 JSON 数据文件...',
  'notebooks.knowledgeGraph.status.processingGraph': '正在处理图谱结构...',
  'notebooks.knowledgeGraph.status.rendering': '正在渲染可视化...',
  'notebooks.knowledgeGraph.status.noGraph': '未加载图谱',
  'notebooks.knowledgeGraph.status.reloadingGraph': '正在重新加载图谱数据...',
  'notebooks.knowledgeGraph.status.graphReloaded': '图谱已重新加载',
  'notebooks.knowledgeGraph.status.rebuilding': '正在重建知识图谱...',
  'notebooks.knowledgeGraph.status.rebuildFailed': '重建失败',

  'notebooks.knowledgeGraph.error.missingNotebookId': '缺少笔记本 ID',
  'notebooks.knowledgeGraph.error.loadFailed': '加载图谱数据失败',
  'notebooks.knowledgeGraph.error.reloadFailed': '重新加载图谱数据失败',
  'notebooks.knowledgeGraph.error.rebuildFailed': '重建知识图谱失败',

  'notebooks.knowledgeGraph.tab.corpus': '语料',
  'notebooks.knowledgeGraph.tab.explore': '探索',
  'notebooks.knowledgeGraph.tab.chat': '对话',
  'notebooks.knowledgeGraph.tab.groups': '群组',
  'notebooks.knowledgeGraph.tab.inspector': '检查器',

  'notebooks.knowledgeGraph.explore.title': '图谱浏览器',
  'notebooks.knowledgeGraph.explore.description': '搜索、筛选并跳转到当前知识图谱中的节点',
  'notebooks.knowledgeGraph.explore.stat.entities': '实体',
  'notebooks.knowledgeGraph.explore.stat.relationships': '关系',
  'notebooks.knowledgeGraph.explore.stat.communities': '社群',
  'notebooks.knowledgeGraph.explore.stat.textUnits': '文本单元',
  'notebooks.knowledgeGraph.explore.query.title': '查询',
  'notebooks.knowledgeGraph.explore.query.placeholder': '搜索实体、描述、模态...',
  'notebooks.knowledgeGraph.explore.query.querying': '服务端查询中...',
  'notebooks.knowledgeGraph.explore.query.resultsHint': '{local} 个本地匹配 · {server} 个服务端匹配',
  'notebooks.knowledgeGraph.explore.query.noResults': '未找到匹配的节点。',
  'notebooks.knowledgeGraph.explore.filters.title': '筛选',
  'notebooks.knowledgeGraph.explore.filters.modality': '模态',
  'notebooks.knowledgeGraph.explore.filters.entityType': '实体类型',
  'notebooks.knowledgeGraph.explore.filters.clear': '清除筛选',
  'notebooks.knowledgeGraph.explore.topEntities': '热门实体',
  'notebooks.knowledgeGraph.explore.topEntitiesLinkCount': '{count} 个链接',
  'notebooks.knowledgeGraph.explore.topRelationships': '强关联关系',
  'notebooks.knowledgeGraph.explore.topCommunities': '最大社群',
  'notebooks.knowledgeGraph.explore.communityFallback': '社群 {id}',
  'notebooks.knowledgeGraph.explore.communityInfo': '第 {level} 层 · {size} 个实体',
  'notebooks.knowledgeGraph.explore.nodeInfo': '{type} · {modality} · {degree} 个链接',
  'notebooks.knowledgeGraph.explore.linkInfo': '权重 {weight} · {description}',

  'notebooks.knowledgeGraph.communities.title': '社群',
  'notebooks.knowledgeGraph.communities.description': '当前图谱中共 {count} 个社群',
  'notebooks.knowledgeGraph.communities.empty': '暂无社群。请先运行图谱索引。',
  'notebooks.knowledgeGraph.communities.communityWithRelInfo': '第 {level} 层 · {size} 个实体 · {rels} 个关系',

  'notebooks.knowledgeGraph.renderer.3d': '3D',
  'notebooks.knowledgeGraph.renderer.large': '大型',
  'notebooks.knowledgeGraph.renderer.3dHint': '详细的 3D 渲染器',
  'notebooks.knowledgeGraph.renderer.largeHint': '适用于大型图谱的实例化 WebGL 渲染器',

  'notebooks.knowledgeGraph.topbar.searchPlaceholder': '搜索实体...',
  'notebooks.knowledgeGraph.topbar.clearSearch': '清除搜索',
  'notebooks.knowledgeGraph.topbar.graphQuery': '图谱查询',
  'notebooks.knowledgeGraph.topbar.querying': '查询中...',
  'notebooks.knowledgeGraph.topbar.queryResults': '显示 {shown} 个 · 服务端 {server} 个',
  'notebooks.knowledgeGraph.topbar.noResults': '未找到匹配的图谱节点。',
  'notebooks.knowledgeGraph.topbar.communityIsolator': '社群隔离器',

  'notebooks.knowledgeGraph.corpus.title': '语料',
  'notebooks.knowledgeGraph.corpus.description': 'GraphRAG 索引管理',
  'notebooks.knowledgeGraph.corpus.loadedKg': '已加载 KG：',
  'notebooks.knowledgeGraph.corpus.noKg': '（无）',
  'notebooks.knowledgeGraph.corpus.rename': '重命名',
  'notebooks.knowledgeGraph.corpus.runIndex': '运行索引',
  'notebooks.knowledgeGraph.corpus.stop': '停止',
  'notebooks.knowledgeGraph.corpus.forceReindex': '强制重建',
  'notebooks.knowledgeGraph.corpus.indexed': '已索引',
  'notebooks.knowledgeGraph.corpus.noIndexPresent': '暂无索引',
  'notebooks.knowledgeGraph.corpus.indexedOverview': '索引概览',
  'notebooks.knowledgeGraph.corpus.lastIndexed': '上次索引时间：{time}',
  'notebooks.knowledgeGraph.corpus.neverIndexed': '从未索引',
  'notebooks.knowledgeGraph.corpus.noIndexHint': '未找到索引。请先在左侧"来源"中添加文件，然后点击"运行索引"来构建知识图谱。',
  'notebooks.knowledgeGraph.corpus.dataset': '数据集',
  'notebooks.knowledgeGraph.corpus.sourceHint': '来源（来自笔记本的 Sources）',
  'notebooks.knowledgeGraph.corpus.noSources': '暂无来源。请在左侧"来源"中添加文件。',
  'notebooks.knowledgeGraph.corpus.archives': '归档',
  'notebooks.knowledgeGraph.corpus.archiveCurrent': '归档当前',
  'notebooks.knowledgeGraph.corpus.noArchives': '暂无归档',
  'notebooks.knowledgeGraph.corpus.restore': '恢复',
  'notebooks.knowledgeGraph.corpus.delete': '删除',
  'notebooks.knowledgeGraph.corpus.jsonFile': 'JSON 文件',
  'notebooks.knowledgeGraph.corpus.import': '导入',
  'notebooks.knowledgeGraph.corpus.pasteContentList': '粘贴 content_list JSON',
  'notebooks.knowledgeGraph.corpus.assetBaseDir': '相对图片路径的资源基础目录',
  'notebooks.knowledgeGraph.corpus.noJsonSelected': '未选择 JSON',
  'notebooks.knowledgeGraph.corpus.terminalLogs': '终端日志',
  'notebooks.knowledgeGraph.corpus.noLogs': '暂无日志。',
  'notebooks.knowledgeGraph.corpus.table.file': '文件',
  'notebooks.knowledgeGraph.corpus.table.size': '大小',
  'notebooks.knowledgeGraph.corpus.table.status': '状态',
  'notebooks.knowledgeGraph.corpus.table.noResults': '无结果。',
  'notebooks.knowledgeGraph.corpus.retry': '重试',
  'notebooks.knowledgeGraph.corpus.retryPipeline': '流水线',
  'notebooks.knowledgeGraph.corpus.retryVector': '向量',
  'notebooks.knowledgeGraph.corpus.retryGraph': '图谱',
  'notebooks.knowledgeGraph.corpus.retryCommunity': '社群',
  'notebooks.knowledgeGraph.corpus.status.indexed': '已索引',
  'notebooks.knowledgeGraph.corpus.status.vectorizing': '向量化中',
  'notebooks.knowledgeGraph.corpus.status.scanning': '扫描中',
  'notebooks.knowledgeGraph.corpus.status.communities': '社群构建中',
  'notebooks.knowledgeGraph.corpus.status.error': '错误',
  'notebooks.knowledgeGraph.corpus.status.removed': '已移除',
  'notebooks.knowledgeGraph.corpus.status.requiresIndexing': '需要索引',
  'notebooks.knowledgeGraph.corpus.stage.vector': '向量',
  'notebooks.knowledgeGraph.corpus.stage.graph': '图谱',
  'notebooks.knowledgeGraph.corpus.stage.community': '社群',
  'notebooks.knowledgeGraph.corpus.stage.failed': '{count} 个失败',
  'notebooks.knowledgeGraph.visualizer.errorTitle': '加载图谱数据失败',
  'notebooks.knowledgeGraph.visualizer.retryLoading': '重新加载',
  'notebooks.knowledgeGraph.visualizer.rebuilding': '重建中...',
  'notebooks.knowledgeGraph.visualizer.rebuildGraph': '重建图谱',
  'notebooks.knowledgeGraph.visualizer.loadingTitle': '正在加载知识图谱',
  'notebooks.knowledgeGraph.visualizer.pctComplete': '已完成 {pct}%',
  'notebooks.knowledgeGraph.visualizer.noKbTitle': '暂无知识库',
  'notebooks.knowledgeGraph.visualizer.noKbDesc': '请上传文档并建立索引以创建知识图谱可视化。',
  'notebooks.knowledgeGraph.visualizer.noKbStart': '快速开始：',
  'notebooks.knowledgeGraph.visualizer.noKbStep1': '1. 将 PDF 上传至 input/ 目录',
  'notebooks.knowledgeGraph.visualizer.noKbStep2': '2. 运行 GraphRAG 索引流程',
  'notebooks.knowledgeGraph.visualizer.noKbStep3': '3. 返回此页面查看图谱可视化',
  'notebooks.knowledgeGraph.visualizer.largeView': '大型图谱视图',
  'notebooks.knowledgeGraph.visualizer.3dView': '3D 图谱视图',
  'notebooks.knowledgeGraph.visualizer.nodeEdgeStats': '{nodes} 个节点 · {edges} 条边',
  'notebooks.knowledgeGraph.visualizer.instancedRenderer': '实例化 WebGL 渲染器',
  'notebooks.knowledgeGraph.visualizer.largeGraphHint': '大型图谱：请使用筛选/搜索进行聚焦探索',
  'notebooks.knowledgeGraph.visualizer.communityEntities': '{size} 个实体',
  'notebooks.knowledgeGraph.visualizer.level.sector': '扇区',
  'notebooks.knowledgeGraph.visualizer.level.system': '系统',
  'notebooks.knowledgeGraph.visualizer.level.subsystem': '子系统',
  'notebooks.knowledgeGraph.visualizer.level.component': '组件',
  'notebooks.knowledgeGraph.visualizer.level.element': '元素',

  'notebooks.knowledgeGraph.inspector.noSelection': '未选择节点',
  'notebooks.knowledgeGraph.inspector.clickHint': '点击图谱中的节点查看详情',
  'notebooks.knowledgeGraph.inspector.connections': '{count} 个连接',
  'notebooks.knowledgeGraph.inspector.frequency': '{count} 次出现',
  'notebooks.knowledgeGraph.inspector.levelLabel': '第 {level} 层',
  'notebooks.knowledgeGraph.inspector.entitiesBadge': '{count} 个实体',
  'notebooks.knowledgeGraph.inspector.idPrefix': 'ID：',
  'notebooks.knowledgeGraph.inspector.confPrefix': '置信度 ',
  'notebooks.knowledgeGraph.inspector.description': '描述',
  'notebooks.knowledgeGraph.inspector.multimodalSource': '多模态来源',
  'notebooks.knowledgeGraph.inspector.modality': '模态',
  'notebooks.knowledgeGraph.inspector.asset': '资源',
  'notebooks.knowledgeGraph.inspector.chunk': '分块',
  'notebooks.knowledgeGraph.inspector.graphAsset': '图谱资源',
  'notebooks.knowledgeGraph.inspector.previewImage': '放大预览',
  'notebooks.knowledgeGraph.inspector.downloadImage': '下载图片',
  'notebooks.knowledgeGraph.inspector.communityHierarchy': '社群层级',
  'notebooks.knowledgeGraph.inspector.parentCommunities': '↑ 父社群（{count}）',
  'notebooks.knowledgeGraph.inspector.currentCommunity': '→ 当前社群',
  'notebooks.knowledgeGraph.inspector.childCommunities': '↓ 子社群（{count}）',
  'notebooks.knowledgeGraph.inspector.strongestRelationships': '最强关系',
  'notebooks.knowledgeGraph.inspector.connectedEntities': '关联实体（{count}）',

  // 实体信息字段标签
  'notebooks.knowledgeGraph.inspector.entityInfo.caption': '说明',
  'notebooks.knowledgeGraph.inspector.entityInfo.semantic_summary': '语义摘要',
  'notebooks.knowledgeGraph.inspector.entityInfo.asset_refs': '资源引用',
  'notebooks.knowledgeGraph.inspector.entityInfo.chunk_metadata': '分块元数据',
  'notebooks.knowledgeGraph.inspector.entityInfo.metadata': '元数据',
  'notebooks.knowledgeGraph.inspector.entityInfo.entities': '实体',
  'notebooks.knowledgeGraph.inspector.entityInfo.name': '名称',
  'notebooks.knowledgeGraph.inspector.entityInfo.type': '类型',
  'notebooks.knowledgeGraph.inspector.entityInfo.description': '描述',
  'notebooks.knowledgeGraph.inspector.entityInfo.confidence': '置信度',

  'notebooks.knowledgeGraph.chat.title': '对话',
  'notebooks.knowledgeGraph.chat.description': '查询文本、实体和多模态图谱上下文',
  'notebooks.knowledgeGraph.chat.clear': '清空',
  'notebooks.knowledgeGraph.chat.modelLabel': '模型：{model}',
  'notebooks.knowledgeGraph.chat.estCost': '预估费用：${cost}（输入 {inTokens} + 输出 {outTokens} tk）',
  'notebooks.knowledgeGraph.chat.mode': '模式：',
  'notebooks.knowledgeGraph.chat.assets': '资源',
  'notebooks.knowledgeGraph.chat.assetsCited': '{count} 个资源被引用',
  'notebooks.knowledgeGraph.chat.getStarted': '开始使用',
  'notebooks.knowledgeGraph.chat.getStartedDesc': '询问知识图谱中的实体、关系或社群。',
  'notebooks.knowledgeGraph.chat.runSteps': '执行步骤',
  'notebooks.knowledgeGraph.chat.step.search': '{mode} 搜索：收集图谱和多模态上下文',
  'notebooks.knowledgeGraph.chat.step.extract': '从查询输出中提取实体 ID',
  'notebooks.knowledgeGraph.chat.step.build': '构建紧凑的知识图谱上下文',
  'notebooks.knowledgeGraph.chat.step.display': '显示 {mode} 响应',
  'notebooks.knowledgeGraph.chat.hideLogs': '隐藏终端输出',
  'notebooks.knowledgeGraph.chat.showLogs': '显示终端输出',
  'notebooks.knowledgeGraph.chat.thinking': '思考中…',
  'notebooks.knowledgeGraph.chat.queryAttachment': '查询附件',
  'notebooks.knowledgeGraph.chat.placeholder': '询问有关图谱的问题…',
  'notebooks.knowledgeGraph.chat.attachTitle': '附加图片、表格或文本查询内容',
  'notebooks.knowledgeGraph.chat.addTableTitle': '添加表格查询内容',
  'notebooks.knowledgeGraph.chat.addEquationTitle': '添加公式查询内容',
  'notebooks.knowledgeGraph.chat.addTextTitle': '添加文本查询内容',
  'notebooks.knowledgeGraph.chat.removeAttachment': '移除附件',
  'notebooks.knowledgeGraph.chat.name': '名称',
  'notebooks.knowledgeGraph.chat.caption': '说明',
  'notebooks.knowledgeGraph.chat.pasteCsv': '粘贴 CSV、TSV 或 Markdown 表格',
  'notebooks.knowledgeGraph.chat.pasteEquation': '粘贴 LaTeX 或公式文本',
  'notebooks.knowledgeGraph.chat.pasteText': '粘贴相关文本',
  'notebooks.knowledgeGraph.chat.role.user': '用户',
  'notebooks.knowledgeGraph.chat.role.assistant': '助手',
    'notebooks.knowledgeGraph.chat.vlmTitle': '要求后端在可用时使用支持视觉能力的回答',
  'notebooks.knowledgeGraph.chat.includeAssets': '在上下文中包含多模态资源',
  'notebooks.knowledgeGraph.chat.inlineTable': '内联表格-{n}',
  'notebooks.knowledgeGraph.chat.inlineEquation': '内联公式-{n}',
  'notebooks.knowledgeGraph.chat.inlineText': '内联文本-{n}',
  'notebooks.knowledgeGraph.chat.highlights': '高亮：{count} 个实体',

	// 实体类型
	'notebooks.knowledgeGraph.entityType.MultimodalImage': '多模态图片',
	'notebooks.knowledgeGraph.entityType.Concept': '概念',
	'notebooks.knowledgeGraph.entityType.Product': '产品',
	'notebooks.knowledgeGraph.entityType.Person': '人物',
	'notebooks.knowledgeGraph.entityType.Organization': '组织',
	'notebooks.knowledgeGraph.entityType.Event': '事件',
	'notebooks.knowledgeGraph.entityType.Document': '文档',
	'notebooks.knowledgeGraph.entityType.Location': '位置',

	// 模态
	'notebooks.knowledgeGraph.modality.image': '图片',
	'notebooks.knowledgeGraph.modality.text': '文本',

}

const notebooksSources = {
  'notebooks.sources.collapsedLabel': '来源',
  'notebooks.sources.title': '来源',
  'notebooks.sources.add': '添加来源',
  'notebooks.sources.addNew': '添加新来源',
  'notebooks.sources.addExisting': '关联已有来源',
  'notebooks.sources.empty.title': '暂无来源',
  'notebooks.sources.empty.description': '添加第一个来源，开始构建你的知识库。',
  'notebooks.sources.delete.title': '删除来源',
  'notebooks.sources.delete.description': '确定要删除此来源吗？此操作不可撤销。',
  'notebooks.sources.delete.cta': '删除',
  'notebooks.sources.remove.title': '从笔记本移除来源',
  'notebooks.sources.remove.description': '确定要将此来源从笔记本移除吗？来源本身不会被删除。',
  'notebooks.sources.refresh': '刷新',
  'notebooks.sources.remove.cta': '移除',
}

const notebooksUpload = {
  'notebooks.upload.zoneTitle': '拖拽文件到此处上传',
  'notebooks.upload.zoneDescription': '或点击选择文件。支持 PDF、Word、Excel、PPT、图片、视频、音频等多种格式',
  'notebooks.upload.dropHint': '释放文件以上传',
  'notebooks.upload.status.pending': '等待上传',
  'notebooks.upload.status.uploading': '上传中...',
  'notebooks.upload.status.uploaded': '已上传，正在创建来源...',
  'notebooks.upload.status.creatingSource': '正在创建来源...',
  'notebooks.upload.status.done': '上传成功',
  'notebooks.upload.status.error': '上传失败',
  'notebooks.upload.completedCount': '{count} 个已完成',
  'notebooks.upload.failedCount': '{count} 个失败',
  'notebooks.upload.clearCompleted': '清除已完成',
}

const notebooksNotes = {
  'notebooks.notes.collapsedLabel': '笔记',
  'notebooks.notes.title': '笔记',
  'notebooks.notes.add': '撰写笔记',
  'notebooks.notes.empty.title': '暂无笔记',
  'notebooks.notes.empty.description': '创建第一条笔记来记录洞见与观察。',
  'notebooks.notes.badge.ai': 'AI 生成',
  'notebooks.notes.badge.human': '人工',
  'notebooks.notes.delete.title': '删除笔记',
  'notebooks.notes.delete.description': '确定要删除这条笔记吗？此操作不可撤销。',
  'notebooks.notes.delete.cta': '删除',
}

const notebooksChat = {
  'notebooks.chat.title': '笔记本对话',
  'notebooks.chat.title.source': '与数据源对话',
  'notebooks.chat.error.title': '无法加载对话',
  'notebooks.chat.error.hint': '请尝试刷新页面',
  'notebooks.chat.error.notFound': '找不到此{type}',
  'notebooks.chat.empty.start': '开始关于此{contextType}的对话',
  'notebooks.chat.empty.hint': '提出问题以更好地理解内容',
  'notebooks.chat.input.placeholder': '提出关于此{contextType}的问题...',
  'notebooks.chat.input.send': '发送',
  'notebooks.chat.sessions': '会话',
  'notebooks.chat.sessions.title': '对话会话',
  'notebooks.chat.sessions.loading': '正在加载会话...',
  'notebooks.chat.sessions.empty': '暂无对话会话',
  'notebooks.chat.sessions.emptyHint': '创建一个会话开始对话',
  'notebooks.chat.sessions.create': '创建',
  'notebooks.chat.sessions.cancel': '取消',
  'notebooks.chat.sessions.placeholder': '会话标题...',
  'notebooks.chat.sessions.messages': '{count} 条消息',
  'notebooks.chat.sessions.delete.title': '删除对话会话？',
  'notebooks.chat.sessions.delete.description': '此操作不可撤销。此会话中的所有消息都将被永久删除。',
  'notebooks.chat.sessions.delete.confirm': '删除',
  'notebooks.chat.model.label': '模型',
  'notebooks.chat.context.source': '数据源',
  'notebooks.chat.context.sources': '数据源',
  'notebooks.chat.context.insight': '洞见',
  'notebooks.chat.context.insights': '洞见',
  'notebooks.chat.context.note': '笔记',
  'notebooks.chat.context.notes': '笔记',
  'notebooks.chat.context.notebook': '笔记本',
  'notebooks.chat.context.notebooks': '笔记本',
  'notebooks.chat.references': '参考资料',
  'notebooks.chat.graphReferences': '知识图谱参考',
  'notebooks.chat.graphReferences.open': '在知识图谱中查看：{name}',
  'notebooks.chat.analysis.show': '显示分析',
  'notebooks.chat.analysis.hide': '隐藏分析',
  'notebooks.chat.analysis.title': '结构化参数',
  'notebooks.chat.analysis.requestPayload': '请求参数',
  'notebooks.chat.analysis.contextSummary': '上下文摘要',
  'notebooks.chat.analysis.contextSelection': '上下文选择',
  'notebooks.chat.analysis.contextRaw': '知识库检索内容',
  'notebooks.chat.analysis.graphContext': '知识图谱检索内容',
  'notebooks.chat.analysis.memorySummary': '长期记忆',
  'notebooks.chat.analysis.memoryPayload': '长期记忆原始数据',
  'notebooks.chat.analysis.llmRequest': 'LLM 请求',
  'notebooks.chat.analysis.responseSummary': '响应摘要',
  'notebooks.chat.actions.save.tooltip': '保存到笔记',
  'notebooks.chat.actions.save.missingNotebook': '无法保存笔记：笔记本 ID 不可用',
  'notebooks.chat.actions.copy.tooltip': '复制到剪贴板',
  'notebooks.chat.actions.copy.success': '消息已复制到剪贴板',
  'notebooks.chat.actions.copy.error': '复制消息失败',
  'notebooks.chat.vector.label': '向量',
  'notebooks.chat.vector.tooltip': '启用向量/混合检索，从已选来源和笔记中查找相关内容注入对话上下文',
  'notebooks.chat.ocr.label': 'OCR',
  'notebooks.chat.ocr.tooltip': '启用光学字符识别以提取文档中的图片和文字内容',
  'notebooks.chat.graph.label': '图谱',
  'notebooks.chat.graph.tooltip': '启用知识图谱检索，从文档中提取的实体和关系将注入到对话上下文中',
  'notebooks.chat.memory.userId.label': '用户 ID',
  'notebooks.chat.memory.userId.placeholder': '留空时默认使用当前客户 ID，例如 customer_1234',
  'notebooks.chat.memory.userId.hint': '支持 `customer_2232`、`user_1234` 这类“类型_编号”格式；默认优先 customer。',
  'notebooks.chat.memory.section.title': '用户 ID 与记忆设置',
  'notebooks.chat.memory.section.description': '展开后可控制画像、记忆、行为的使用与记录。',
  'notebooks.chat.memory.section.expand': '展开',
  'notebooks.chat.memory.section.collapse': '收起',
  'notebooks.chat.memory.use.userProfile': '使用用户画像',
  'notebooks.chat.memory.use.userMemory': '使用用户记忆',
  'notebooks.chat.memory.use.userBehavior': '使用用户行为',
  'notebooks.chat.memory.record.userProfile': '记录用户画像',
  'notebooks.chat.memory.record.userMemory': '记录用户记忆',
  'notebooks.chat.memory.record.userBehavior': '记录用户行为',
}

const notebooksEditor = {
  'notebooks.editor.editTitle': '编辑笔记',
  'notebooks.editor.createTitle': '创建笔记',
  'notebooks.editor.placeholder.title': '添加标题...',
  'notebooks.editor.placeholder.untitled': '无标题笔记',
  'notebooks.editor.placeholder.content': '在这里撰写笔记内容...',
  'notebooks.editor.loading': '正在加载笔记…',
  'notebooks.editor.actions.cancel': '取消',
  'notebooks.editor.actions.saving': '保存中...',
  'notebooks.editor.actions.creating': '创建中...',
  'notebooks.editor.actions.save': '保存笔记',
  'notebooks.editor.actions.create': '创建笔记',
  'notebooks.editor.validation.contentRequired': '内容不能为空',
}

const notebookAssociations = {
  'notebookAssociations.title': '笔记本',
  'notebookAssociations.description': '管理包含此来源的笔记本',
  'notebookAssociations.noNotebooks': '暂无笔记本',
  'notebookAssociations.save': '保存更改',
}

const commonCommandPalette = {
  'commandPalette.title': '命令面板',
  'commandPalette.description': '导航、搜索或向知识库提问',
  'commandPalette.placeholder': '输入命令或搜索内容...',
  'commandPalette.section.searchAsk': '搜索与提问',
  'commandPalette.section.navigation': '导航',
  'commandPalette.section.notebooks': '笔记本',
  'commandPalette.section.create': '新建',
  'commandPalette.section.theme': '主题',
  'commandPalette.section.searchPrompt': '或搜索你的知识库',
  'commandPalette.search.label': '搜索 “{query}”',
  'commandPalette.ask.label': '提问 “{query}”',
  'commandPalette.notebooks.loading': '正在加载笔记本...',
  'commandPalette.create.source': '新建来源',
  'commandPalette.create.notebook': '新建笔记本',
  'commandPalette.theme.light': '浅色主题',
  'commandPalette.theme.dark': '深色主题',
  'commandPalette.theme.system': '跟随系统',
}

const commonAddButton = {
  'addButton.add': '添加',
  'addButton.source': '来源',
  'addButton.notebook': '笔记本',
  'addButton.notebook.soon': '即将推出',
}

const commonTheme = {
  'theme.toggle.label': '主题',
  'theme.toggle.sr': '切换主题',
  'theme.option.light': '浅色',
  'theme.option.dark': '深色',
  'theme.option.system': '系统',
}

const commonActions = {
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.stay_tuned': '敬请期待',
  'common.loading': '加载中...',
  'common.save': '保存',
  'common.saving': '保存中...',
  'common.auto_refresh_on': '自动刷新已开启',
  'common.auto_refresh_off': '自动刷新已关闭',
}

const commonConfirmDialog = {
  'confirmDialog.confirm': '确认',
  'confirmDialog.cancel': '取消',
}

const commonErrorBoundary = {
  'errorBoundary.title': '出现了一些问题',
  'errorBoundary.description': '发生了意外错误，请尝试刷新页面。',
  'errorBoundary.details': '错误详情',
  'errorBoundary.tryAgain': '重试',
  'errorBoundary.refresh': '刷新页面',
}

const commonConnection = {
  'connection.api.unreachable.title': '无法连接到 API 服务器',
  'connection.api.unreachable.subtitle': '无法访问 FishOwn Agent API 服务器',
  'connection.db.offline.title': '数据库连接失败',
  'connection.db.offline.subtitle': 'API 服务器已运行，但数据库无法访问',
  'connection.guide.heading': '通常意味着：',
  'connection.guide.api.item1': 'API 服务器未运行',
  'connection.guide.api.item2': 'API 服务器运行在其他地址',
  'connection.guide.api.item3': '网络连接问题',
  'connection.guide.db.item1': 'PostgreSQL 未运行',
  'connection.guide.db.item2': '数据库连接配置错误',
  'connection.guide.db.item3': 'API 与数据库之间的网络问题',
  'connection.guide.quick.heading': '快速排查：',
  'connection.quick.api.title': '设置 API_URL 环境变量：',
  'connection.quick.db.title': '检查 PostgreSQL 是否运行：',
  'connection.docs.prefix': '更多部署/配置说明参见：',
  'connection.docs.link': 'FishOwn Agent 文档',
  'connection.details.toggle': '展开技术细节',
  'connection.details.attemptedUrl': '请求地址：',
  'connection.details.message': '提示信息：',
  'connection.details.technical': '技术细节：',
  'connection.details.stack': '堆栈：',
  'connection.retry': '重试连接',
  'connection.retry.hint': '按 R 或点击按钮重试',
}

const commonModelSelector = {
  'modelSelector.placeholder': '选择一个模型',
  'modelSelector.empty.language': '暂无语言模型',
  'modelSelector.empty.embedding': '暂无向量模型',
  'modelSelector.empty.speech_to_text': '暂无语音转文本模型',
  'modelSelector.empty.text_to_speech': '暂无文本转语音模型',
  'modelSelector.empty.generic': '暂无可用模型',
}

const modelSelectorDialog = {
  'modelSelector.dialog.title': '模型配置',
  'modelSelector.dialog.description': '为此聊天会话覆盖默认模型。留空以使用系统默认值。',
  'modelSelector.dialog.label': '模型',
  'modelSelector.dialog.placeholder': '选择一个模型（或使用默认值）',
  'modelSelector.dialog.option.default': '默认',
  'modelSelector.dialog.option.systemModel': '系统模型',
  'modelSelector.dialog.defaultWithModel': '默认 ({model})',
  'modelSelector.dialog.systemDefault': '系统默认',
  'modelSelector.dialog.usingCustom': '此会话将使用 <strong>{model}</strong> 而不是默认模型。',
  'modelSelector.dialog.reset': '重置为默认',
  'modelSelector.dialog.save': '保存更改',
  'modelSelector.dialog.defaultModel': '默认模型',
}

const commonContextToggle = {
  'contextToggle.off': '不参与对话',
  'contextToggle.insights': '仅用洞见',
  'contextToggle.full': '使用全文',
  'contextToggle.cycle': '点击切换',
}

const commonContextIndicator = {
  'contextIndicator.empty': '当前对话未包含任何来源或笔记，点击卡片图标可将其加入上下文。',
  'contextIndicator.label': '上下文：',
  'contextIndicator.tooltip.insights': '{count} 个来源的洞见',
  'contextIndicator.tooltip.sources': '{count} 个来源全文',
  'contextIndicator.tooltip.notes': '{count} 条笔记全文',
  'contextIndicator.tooltip.graph': '{entities} 个知识图谱实体 / {relationships} 个关系',
  'contextIndicator.vectorDisabled': '向量检索已关闭',
  'contextIndicator.tokens': '{count} tokens',
  'contextIndicator.chars': '{count} 字符',
}

const searchPage = {
  'search.page.title': '提问与搜索',
  'search.page.description': '向知识库提问，或搜索来源和笔记中的内容。',
  'search.page.mode.label': '选择模式',
  'search.page.mode.ariaLabel': '向知识库提问或搜索',
  'search.page.mode.ask': '提问 (beta)',
  'search.page.mode.search': '搜索',
  'search.ask.title': '向知识库提问 (beta)',
  'search.ask.description': 'LLM 将根据你知识库中的文档来回答问题。',
  'search.ask.question.label': '问题',
  'search.ask.question.placeholder': '输入你的问题...',
  'search.ask.question.shortcut': '按 Cmd/Ctrl+Enter 提交',
  'search.ask.error.noEmbeddingModel': '你尚未选择向量模型，无法使用此功能。请在“模型”页面中设置。',
  'search.ask.models.custom': '使用自定义模型',
  'search.ask.models.default': '使用默认模型',
  'search.ask.models.advanced': '高级',
  'search.ask.models.strategy': '策略: {model}',
  'search.ask.models.answer': '回答: {model}',
  'search.ask.models.final': '最终: {model}',
  'search.ask.models.notSet': '未设置',
  'search.ask.actions.processing': '处理中...',
  'search.ask.actions.ask': '提问',
  'search.ask.actions.saveToNotebook': '保存到笔记本',
  'search.search.title': '搜索',
  'search.search.description': '在知识库中搜索特定的关键词或概念',
  'search.search.query.placeholder': '输入搜索查询...',
  'search.search.actions.search': '搜索',
  'search.search.query.shortcut': '按 Enter 搜索',
  'search.search.options.type.label': '搜索类型',
  'search.search.options.type.noEmbeddingModel': '向量搜索需要向量模型。当前仅文本搜索可用。',
  'search.search.options.type.text': '文本搜索',
  'search.search.options.type.vector': '向量搜索',
  'search.search.options.type.hybrid': '聚合搜索',
  'search.search.options.location.label': '搜索范围',
  'search.search.options.location.sources': '搜索来源',
  'search.search.options.location.notes': '搜索笔记',
  'search.results.count': '找到 {count} 个结果',
  'search.results.type': '{type} 搜索',
  'search.results.empty': '未找到与 “{query}” 相关的结果',
  'search.results.matches': '匹配项 ({count})',
}

const sourcesPage = {
  'sources.page.title': '所有来源',
  'sources.page.description': '浏览所有笔记本中的来源。使用方向键导航，按 Enter 打开。',
  'sources.page.empty.title': '暂无来源',
  'sources.page.empty.description': '所有笔记本的来源都将在此处显示',
  'sources.page.error.load': '加载来源失败',
  'sources.page.error.delete': '删除来源失败',
  'sources.page.success.delete': '来源删除成功',
  'sources.page.table.type': '类型',
  'sources.page.table.title': '标题',
  'sources.page.table.created': '创建时间',
  'sources.page.table.insights': '洞见',
  'sources.page.table.embedded': '已向量化',
  'sources.page.table.knowledgeGraph': '可知识图谱',
  'sources.page.table.actions': '操作',
  'sources.page.type.link': '链接',
  'sources.page.type.file': '文件',
  'sources.page.type.text': '文本',
  'sources.page.type.unknown': '未知',
  'sources.page.untitled': '无标题来源',
  'sources.page.embedded.yes': '是',
  'sources.page.embedded.no': '否',
  'sources.page.embedded.readyForGraphRAG': '可知识图谱',
  'sources.page.knowledgeGraph.built': '已构建',
  'sources.page.knowledgeGraph.ready': '可构建',
  'sources.page.knowledgeGraph.notAvailable': '—',
  'sources.page.loadingMore': '正在加载更多来源...',
  'sources.page.delete.title': '删除来源',
  'sources.page.delete.description': '确定要删除 “{title}” 吗？此操作不可撤销。',
  'sources.page.delete.cta': '删除',
}

const auth = {
  'auth.login.title': 'FishOwn Agent',
  'auth.login.description': '通过远端认证门户登录。',
  'auth.login.remote.iframeTitle': '远端身份验证门户',
  'auth.login.remote.waiting': '正在等待远端登录完成…',
  'auth.login.remote.missingUrl': '未配置远端登录 URL。',
  'auth.login.remote.missingUrlDescription': '请在启动 Dashboard 前设置 NEXT_PUBLIC_REMOTE_LOGIN_URL 指向远端登录页面。',
  'auth.login.passwordPlaceholder': '密码',
  'auth.login.signIn': '登录',
  'auth.login.signingIn': '登录中...',
  'auth.login.error.connection.title': '连接错误',
  'auth.login.error.connection.description': '无法连接到 API 服务器',
  'auth.login.error.connection.detailed': '无法连接到服务器。请检查 API 是否正在运行。',
  'auth.login.error.diagnostics.title': '诊断信息:',
  'auth.login.error.diagnostics.version': '版本: {version}',
  'auth.login.error.diagnostics.built': '构建于: {buildTime}',
  'auth.login.error.diagnostics.apiUrl': 'API URL: {apiUrl}',
  'auth.login.error.diagnostics.frontend': '前端: {url}',
  'auth.login.error.diagnostics.checkConsole': '查看浏览器控制台以获取详细日志 (寻找 🔧 [Config] 消息)',
  'auth.login.error.retry': '重试连接',
}

const bananaproPage = {
  'bananapro.title': 'Nano Banana Pro 编辑器',
  'bananapro.engine_badge': 'Gemini 3 Pro',
  'bananapro.description': '支持文本编辑、局部增强与一键风格化，适配 Nano Banana Pro。',
  'bananapro.parameters.title': '参数',
  'bananapro.parameters.description': '调整模型、比例与分辨率，匹配目标画面需求。',
  'bananapro.model_selection': '选择模型',
  'bananapro.model_placeholder': '选择模型',
  'bananapro.aspect_ratio': '画面比例',
  'bananapro.resolution': '分辨率',
  'bananapro.images.title': '最多 10 张图片',
  'bananapro.images.description': '添加要编辑的图片（选填）',
  'bananapro.images.secondary': '留空则根据提示词生成',
  'bananapro.images.action': '尝试画布模式',
  'bananapro.images.empty': '暂无图片，拖拽文件到上方开始。',
  'bananapro.prompt': '提示词',
  'bananapro.prompt_placeholder': '描述你想要编辑或生成的画面内容',
  'bananapro.intensity': '处理强度',

  'bananapro.generate': '生成（{credits} 积分）',
  'bananapro.output.title': '输出',
  'bananapro.output.description': '切换 Before / After 查看编辑效果。',
  'bananapro.output.before': '编辑前',
  'bananapro.output.after': '编辑后',
  'bananapro.output.prompt_label': '提示词',
  'bananapro.copy_prompt': '复制提示词',
  'bananapro.download_image': '下载图像',
  'bananapro.edit_again': '再次编辑',
  'bananapro.recent.title': '最近创作',
}

const imageGeneratorPage = {
  'image_generator.page.title': '图片生成',
  'image_generator.page.description': '使用多种 AI 模型生成图片。',
  'image_generator.tab.ecommerce': '电商商品',
  'image_generator.tab.midjourney': 'MidJourney',
  'image_generator.tab.nano_banana_pro': 'Nano Banana Pro',
  'image_generator.tab.midjourney_v7': 'Midjourney V7',
  'image_generator.tab.video_generator': '视频生成',
}

const videoGeneratorPage = {
  'video_generator.script_settings': '文案设置',
  'video_generator.video_subject': '视频主题',
  'video_generator.video_subject_placeholder': '请输入视频主题，AI 将自动生成视频文案',
  'video_generator.script_language': '文案语言',
  'video_generator.auto_detect': '自动检测',
  'video_generator.generate_script': '生成视频文案和关键词',
  'video_generator.video_script': '视频文案',
  'video_generator.video_script_help': 'AI 生成的视频文案，可编辑后生成视频',
  'video_generator.generate_keywords': '生成视频关键词',
  'video_generator.video_keywords': '视频关键词',
  'video_generator.video_keywords_help': '用于搜索视频素材的关键词，逗号分隔',
  'video_generator.video_settings': '视频设置',
  'video_generator.tab_talk_show': '口播视频',
  'video_generator.tab_material_video': '素材视频',
  'video_generator.personal_avatar': '个人形象',
  'video_generator.personal_avatar_selected': '已选择',
  'video_generator.personal_avatar_placeholder': '请选择一个个人形象，用于口播视频中的数字人展示',
  'video_generator.hd_mode': '高清模式',
  'video_generator.hd_mode_help': '开启后视频将以更高分辨率输出，生成时间会相应增加',
  'video_generator.video_source': '视频素材来源',
  'video_generator.pexels': 'Pexels',
  'video_generator.pixabay': 'Pixabay',
  'video_generator.local_file': '资源库',
  'video_generator.video_concat_mode': '视频拼接模式',
  'video_generator.sequential': '顺序拼接',
  'video_generator.random': '随机拼接',
  'video_generator.video_ratio': '视频比例',
  'video_generator.portrait': '竖屏 9:16',
  'video_generator.landscape': '横屏 16:9',
  'video_generator.clip_duration': '片段时长（秒）',
  'video_generator.video_count': '同时生成数量',
  'video_generator.coverr': 'Coverr',
  'video_generator.match_materials_to_script': '素材匹配文案顺序',
  'video_generator.match_materials_to_script_help': '开启后关键词到合成全程保持叙事顺序，拼接模式自动锁定为顺序拼接',
  'video_generator.video_transition_mode': '视频转场模式',
  'video_generator.transition_none': '无转场',
  'video_generator.transition_shuffle': '随机',
  'video_generator.transition_fade_in': '淡入',
  'video_generator.transition_fade_out': '淡出',
  'video_generator.transition_slide_in': '滑入',
  'video_generator.transition_slide_out': '滑出',
  'video_generator.video_encoder': '视频编码器',
  'video_generator.encoder_default': '默认编码器',
  'video_generator.encoder_help': '选择视频编码格式，默认使用 libx264（CPU 编码）',
  'video_generator.upload_local_files': '从资源库选择素材',
  'video_generator.upload_local_files_placeholder': '请先在资源库中上传 mp4, mov, avi, flv, mkv, jpg, jpeg, png 格式的素材',
  'video_generator.audio_settings': '音频设置',
  'video_generator.tts': 'AI 配音',
  'video_generator.upload_voice': '上传配音',
  'video_generator.no_voice': '无配音',
  'video_generator.upload_voice_from_library': '从资源库选择旁白视频',
  'video_generator.upload_voice_pick_audio': '从资源库选择音频',
  'video_generator.asr_model': 'ASR语音转文字识别模型',
  'video_generator.voiceover_service': '配音服务',
  'video_generator.voiceover_voice': '配音音色',
  'video_generator.voiceover_voice_placeholder': '选择音色',
  'video_generator.voiceover_voice_no_voices': '当前所选配音服务没有可用音色，请选择其他服务。',
  'video_generator.voiceover_volume': '配音音量',
  'video_generator.voiceover_speed': '配音语速',
  'video_generator.bgm_source': '背景音乐',
  'video_generator.no_bgm': '无背景音乐',
  'video_generator.library_bgm': '曲库背景音乐',
  'video_generator.custom_bgm': '自定义背景音乐',
  'video_generator.bgm_volume': '背景音乐音量',
  'video_generator.bgm_library_type': '曲库类型',
  'video_generator.bgm_library_song': '选择曲子',
  'video_generator.bgm_preview': '试听',
  'video_generator.bgm_stop': '停止',
  'video_generator.bgm_library_total': '曲库共 {total} 首可选',
  'video_generator.custom_bgm_file': '自定义背景音乐文件名',
  'video_generator.custom_bgm_file_placeholder': '输入 resource/songs 目录下的 mp3 文件名，如 bgm01.mp3',
  'video_generator.play_voice': '试听配音',
  'video_generator.play_voice_empty': '请先输入视频主题或文案以生成试听内容',
  'video_generator.clone_my_voice': '克隆我的声音',
  'video_generator.clone_my_voice_desc': '上传你的声音样本，生成专属克隆声音',
  'video_generator.select_voice_with_clone': '选择声音（含克隆声音）',
  'video_generator.select_voice_with_clone_placeholder': '选择声音',
  'video_generator.voice_emotion': '情绪',
  'video_generator.emotion_none': '自然（无情绪）',
  'video_generator.emotion_happy': '开心',
  'video_generator.emotion_sad': '悲伤',
  'video_generator.emotion_angry': '愤怒',
  'video_generator.emotion_fearful': '紧张',
  'video_generator.emotion_disgusted': '厌恶',
  'video_generator.emotion_surprised': '惊讶',
  'video_generator.emotion_calm': '平静',
  'video_generator.upload_voice_file': '上传配音文件',
  'video_generator.upload_voice_file_help': '支持 mp3, wav, m4a, aac, flac, ogg 格式',
  'video_generator.upload_voice_file_info': '上传的音频将直接用于合成，不会走 TTS 合成。',
  'video_generator.azure_speech_region': 'Azure 语音区域',
  'video_generator.azure_speech_key': 'Azure 语音密钥',
  'video_generator.siliconflow_api_key': 'SiliconFlow API Key',
  'video_generator.gemini_tts_api_key': 'Google Gemini API Key',
  'video_generator.mimo_api_key': 'MiMo API Key',
  'video_generator.elevenlabs_api_key': 'ElevenLabs API Key',
  'video_generator.elevenlabs_model': 'ElevenLabs 模型',
  'video_generator.chatterbox_base_url': 'Chatterbox Base URL',
  'video_generator.chatterbox_base_url_placeholder': 'http://127.0.0.1:4123/v1',
  'video_generator.chatterbox_api_key': 'Chatterbox API Key',
  'video_generator.chatterbox_model': 'Chatterbox Model',
  'video_generator.chatterbox_voices': 'Chatterbox Voices',
  'video_generator.chatterbox_voices_placeholder': '逗号分隔，如 default-Female, default-Male',
  'video_generator.subtitle_settings': '视频剪辑',
  'video_generator.enable_subtitles': '启用字幕',
  'video_generator.subtitle_font': '字幕字体',
  'video_generator.subtitle_position': '字幕位置',
  'video_generator.subtitle_top': '顶部',
  'video_generator.subtitle_bottom': '底部',
  'video_generator.subtitle_color': '字体颜色',
  'video_generator.subtitle_font_size': '字体大小',
  'video_generator.subtitle_stroke_color': '描边颜色',
  'video_generator.subtitle_stroke_width': '描边宽度',
  'video_generator.subtitle_center': '居中',
  'video_generator.subtitle_custom': '自定义',
  'video_generator.custom_position': '自定义位置（距顶部 %）',
  'video_generator.custom_position_invalid': '请输入 0 到 100 之间的有效数字',
  'video_generator.subtitle_background_enabled': '启用手幕背景',
  'video_generator.subtitle_background_color': '字幕背景颜色',
  'video_generator.rounded_subtitle_background': '圆角字幕背景',
  'video_generator.rounded_subtitle_background_help': '为字幕背景添加圆角效果',
  'video_generator.restore_default_subtitle': '恢复默认字幕设置',
  'video_generator.default_subtitle_restored': '已恢复为默认字幕设置',
  'video_generator.generate_video': '生成视频',
  'video_generator.please_enter_subject': '请先输入视频主题',
  'video_generator.please_enter_script': '请先输入视频文案',
  'video_generator.advanced_script_settings': '高级文案设置',
  'video_generator.paragraph_number': '段落数量',
  'video_generator.custom_script_requirements': '自定义文案要求',
  'video_generator.custom_script_requirements_placeholder': '输入额外要求，如「每段不超过50字」「用轻松幽默的风格」',
  'video_generator.custom_system_prompt': '自定义系统提示词',
  'video_generator.restore_default_prompt': '恢复默认提示词',
  'video_generator.default_prompt_restored': '已恢复为默认系统提示词',
  'video_generator.preview_final_prompt': '预览最终提示词',
  'video_generator.final_prompt_preview': '最终提示词预览',
  'video_generator.close': '关闭',
  'video_generator.task_manager': '任务管理',
  'video_generator.task_manager_no_tasks': '暂无任务',
  'video_generator.task_status_all': '全部',
  'video_generator.task_status_processing': '生成中',
  'video_generator.task_status_complete': '已完成',
  'video_generator.task_status_failed': '失败',
  'video_generator.task_subject': '任务主题',
  'video_generator.task_updated_at': '更新时间',
  'video_generator.task_progress': '进度',
  'video_generator.task_actions': '操作',
  'video_generator.settings': '设置',
  'video_generator.settings_material_api': '素材API',
  'video_generator.settings_cache_management': '缓存管理',
  'video_generator.pexels_api_key': 'Pexels API Key',
  'video_generator.pixabay_api_key': 'Pixabay API Key',
  'video_generator.coverr_api_key': 'Coverr API Key',
  'video_generator.coverr_api_key_help': 'Coverr 大部分素材为 16:9 横屏，选 Coverr 时建议将视频比例设为横屏。',
  'video_generator.get_api_key': '获取 API Key',
  'video_generator.credential_mode': '配置方式',
  'video_generator.credential_mode_system': '系统配置',
  'video_generator.credential_mode_custom': '自定义配置',
  'video_generator.api_key_status_system': '当前使用系统配置的 API Key',
  'video_generator.api_key_status_tenant': '已配置租户 Key',
  'video_generator.api_key_placeholder': '输入 API Key',
  'video_generator.auto_saved': '已自动保存',
  'video_generator.saving': '保存中...',
  'video_generator.cache_directory': '缓存目录',
  'video_generator.cache_file_count': '缓存文件数',
  'video_generator.cache_total_size': '缓存总大小',
  'video_generator.cache_oldest_date': '最早缓存日期',
  'video_generator.cache_cleanup_range': '清理范围',
  'video_generator.cache_older_than_30_days': '30天前',
  'video_generator.cache_older_than_7_days': '7天前',
  'video_generator.cache_older_than_90_days': '90天前',
  'video_generator.cache_all': '全部缓存',
  'video_generator.cache_cleanup_preview': '将清理 {count} 个文件，共 {size}',
  'video_generator.cache_cleanup_confirm': '确认清除缓存',
  'video_generator.refresh_cache': '刷新统计',
  'video_generator.clean_cache_now': '立即清理',
  'video_generator.cache_cleanup_completed': '已清理 {count} 个文件，释放 {size}',
  'video_generator.cache_cleanup_failed': '清理完成，{count} 个文件已删除，{failed} 个失败',
  'video_generator.api_key_saved': 'API Key 已保存',
  'video_generator.task_delete': '删除',
  'video_generator.task_delete_confirm_title': '确认删除任务',
  'video_generator.task_delete_confirm_description': '删除任务「{subject}」后，该任务将从列表中移除，相关文件仍保留在服务器上。',
  'video_generator.task_delete_confirm_running': '删除前将先停止后台任务。「{subject}」执行中的任务会被标记为失败，相关文件仍保留在服务器上。',
  'video_generator.task_delete_success': '任务已删除',
  'video_generator.task_delete_failed': '删除任务失败',
  'video_generator.task_delete_running_warning': '该任务正在运行中，删除前会先停止后台任务并将其标记为失败。',
  'video_generator.tab_original_copy': '原创文案',
  'video_generator.tab_borrow_wind': '仿写文案',
  'video_generator.douyin_link_placeholder': '粘贴抖音分享内容或视频链接...',
  'video_generator.extract_script': '提取文案',
  'video_generator.target_video_script': '目标视频文案',
  'video_generator.rewrite_script_and_keywords': '仿写视频文案和关键词',
  'video_generator.borrow_wind_video_script': '视频文案',
  'video_generator.borrow_wind_video_keywords': '视频关键词',
  'video_generator.upload_reference_video': '上传参考视频',
  'video_generator.upload_reference_video_help': '支持上传视频文件，用于提取和仿写文案',
  'video_generator.extracting_script': '文案提取中...',
  'video_generator.extract_script_success': '文案提取成功',
  'video_generator.extract_script_failed': '文案提取失败',
  'video_generator.extract_script_no_source': '请先选择参考视频',
  'video_generator.extract_script_cache_hint': '已使用素材库中缓存的文案',
}


const addSourceDialog = {
  'addSourceDialog.title': '添加新来源',
  'addSourceDialog.description': '从链接、上传或文本向笔记本添加内容。',
  'addSourceDialog.step1.title': '来源与内容',
  'addSourceDialog.step1.description': '选择类型并添加内容',
  'addSourceDialog.step2.title': '组织',
  'addSourceDialog.step2.description': '选择笔记本',
  'addSourceDialog.step3.title': '处理',
  'addSourceDialog.validation.required': '请为所选来源类型提供必需的内容',
  'addSourceDialog.validation.titleRequired': '文本来源需要标题',
  'addSourceDialog.processing.batchMessage': '正在处理 {itemCount} 个来源...',
  'addSourceDialog.processing.batchSuccess': '成功创建 {successCount} 个来源',
  'addSourceDialog.processing.batchFailed': '创建所有 {failedCount} 个来源失败',
  'addSourceDialog.processing.batchPartial': '{successCount} 个成功, {failedCount} 个失败',
  'addSourceDialog.processing.singleMessage': '正在提交来源进行处理...',
  'addSourceDialog.processing.errorMessage': '创建来源时出错。请重试。',
  'addSourceDialog.processing.batchTitle': '正在处理批次',
  'addSourceDialog.processing.singleTitle': '正在处理来源',
  'addSourceDialog.processing.batchDescription': '正在处理 {total} 个来源。这可能需要一些时间。',
  'addSourceDialog.processing.singleDescription': '正在处理你的来源。这可能需要一些时间。',
  'addSourceDialog.processing.label': '处理中...',
  'addSourceDialog.processing.completed': '{completed} 已完成',
  'addSourceDialog.processing.failed': '{failed} 失败',
  'addSourceDialog.processing.currentItem': '当前: {currentItem}',
  'addSourceDialog.actions.cancel': '取消',
  'addSourceDialog.actions.back': '返回',
  'addSourceDialog.actions.next': '下一步',
  'addSourceDialog.actions.creating': '创建中...',
  'addSourceDialog.actions.done': '完成',
  'addSourceDialog.type.link.label': '链接',
  'addSourceDialog.type.link.description': '添加网页或 URL',
  'addSourceDialog.type.upload.label': '上传',
  'addSourceDialog.type.upload.description': '上传文档或文件',
  'addSourceDialog.type.text.label': '文本',
  'addSourceDialog.type.text.description': '直接添加文本内容',
  'addSourceDialog.type.title': '来源类型',
  'addSourceDialog.type.description': '选择添加内容的方式',
  'addSourceDialog.type.link.labelUrl': 'URL(s) *',
  'addSourceDialog.type.link.urlCount': '{count} 个 URL',
  'addSourceDialog.type.link.urlCount_plural': '{count} 个 URL',
  'addSourceDialog.type.maxSize': '最多 {size}',
  'addSourceDialog.type.link.placeholder': '输入 URL，每行一个\nhttps://example.com/article1\nhttps://example.com/article2',
  'addSourceDialog.type.link.batchHint': '粘贴多个 URL（每行一个）以批量导入',
  'addSourceDialog.type.link.invalidUrlError': '检测到无效的 URL：',
  'addSourceDialog.type.link.line': '行 {line}',
  'addSourceDialog.type.link.fixInvalidUrlHint': '请修正或移除无效的 URL 以继续',
  'addSourceDialog.type.upload.labelFile': '文件 *',
  'addSourceDialog.type.upload.fileCount': '{count} 个文件',
  'addSourceDialog.type.upload.fileCount_plural': '{count} 个文件',
  'addSourceDialog.type.upload.batchHint': '选择多个文件以批量导入。支持：文档 (PDF, DOC, DOCX, PPT, XLS, EPUB, TXT, MD), 媒体 (MP4, MP3, WAV, M4A), 图片 (JPG, PNG), 压缩包 (ZIP)',
  'addSourceDialog.type.upload.selectedFiles': '已选文件:',
  'addSourceDialog.type.upload.fileSize': '{size} KB',
  'addSourceDialog.type.upload.maxSizeError': '每批次最多允许 {size} 个文件',
  'addSourceDialog.type.text.labelContent': '文本内容 *',
  'addSourceDialog.type.text.placeholder': '在此处粘贴或输入内容...',
  'addSourceDialog.title.required': '标题 *',
  'addSourceDialog.title.optional': '标题 (可选)',
  'addSourceDialog.title.textHint': '文本内容需要标题',
  'addSourceDialog.title.genericHint': '如果留空，将根据内容生成标题',
  'addSourceDialog.title.placeholder': '为你的来源起一个描述性的标题',
  'addSourceDialog.batchMode.title': '批量模式',
  'addSourceDialog.batchMode.description': '将处理 {count} 个 {type}',
  'addSourceDialog.step2.notebooks.title': '选择笔记本 (可选)',
  'addSourceDialog.step2.notebooks.description': '选择包含此来源的笔记本。你可以选择多个笔记本或留空。',
  'addSourceDialog.step2.notebooks.empty': '未找到笔记本。',
  'addSourceDialog.step3.processing.title': '处理设置',
  'addSourceDialog.step3.processing.description': '配置来源的处理和存储方式。',
  'addSourceDialog.step3.processing.embed.label': '启用向量化以便搜索',
  'addSourceDialog.step3.processing.embed.description': '允许此来源在向量搜索和 AI 查询中被找到',
  'addSourceDialog.step3.processing.embed.auto.label': '自动启用向量化',
  'addSourceDialog.step3.processing.embed.auto.description': '你的设置已配置为始终对内容进行向量化以便搜索。你可以在 {settingsLink} 中更改此设置。',
  'addSourceDialog.step3.processing.embed.disabled.label': '向量化已禁用',
  'addSourceDialog.step3.processing.embed.disabled.description': '你的设置已配置为跳过向量化。此来源将无法用于向量搜索。你可以在 {settingsLink} 中更改此设置。',
  'addSourceDialog.step3.processing.graphrag.label': '启用知识图谱索引 (GraphRAG)',
  'addSourceDialog.error.noOcrModel': '无法启用 OCR，因为未选择 OCR 模型。请在模型页面配置一个。',
  'addSourceDialog.step3.processing.graphrag.description': '构建实体和关系图谱，支持复杂问答和知识发现',
}

const addExistingSourceDialog = {
  'addExistingSourceDialog.title': '添加已有来源',
  'addExistingSourceDialog.description': '搜索并选择已有来源以添加到此笔记本',
  'addExistingSourceDialog.searchPlaceholder': '搜索来源...',
  'addExistingSourceDialog.loading': '正在加载来源...',
  'addExistingSourceDialog.noResults': '未找到来源',
  'addExistingSourceDialog.untitled': '无标题',
  'addExistingSourceDialog.linked': '已关联',
  'addExistingSourceDialog.addedOn': '添加于 {date}',
  'addExistingSourceDialog.truncationWarning': '仅显示前 100 个来源。请使用搜索功能查找特定来源。',
  'addExistingSourceDialog.selectionCount': '已选择 {count} 个来源',
  'addExistingSourceDialog.selectionCount_plural': '已选择 {count} 个来源',
  'addExistingSourceDialog.actions.cancel': '取消',
  'addExistingSourceDialog.actions.adding': '添加中...',
  'addExistingSourceDialog.actions.addSelected': '添加所选',
}

const createNotebookDialog = {
  'createNotebookDialog.title': '创建新笔记本',
  'createNotebookDialog.description': '为相关的来源和笔记创建一个专属空间，开始组织你的研究。',
  'createNotebookDialog.name.label': '名称 *',
  'createNotebookDialog.name.placeholder': '输入笔记本名称',
  'createNotebookDialog.name.required': '名称不能为空',
  'createNotebookDialog.description.label': '描述',
  'createNotebookDialog.description.placeholder': '描述此笔记本的用途和范围...',
  'createNotebookDialog.actions.cancel': '取消',
  'createNotebookDialog.actions.creating': '创建中…',
  'createNotebookDialog.actions.create': '创建笔记本',
}

const collapsibleColumn = {
  'collapsibleColumn.expand': '展开 {label}',
  'collapsibleColumn.collapse': '折叠 {label}',
}

const modelsPage = {
  'models.page.loadError': '模型数据加载失败',
  'models.page.title': '模型管理',
  'models.page.description': '配置 FishOwn Agent 中用于不同目的的 AI 模型',
}

const providerStatus = {
  'providerStatus.title': 'AI 提供商',
  'providerStatus.description': '通过环境变量配置提供商以启用其模型。',
  'providerStatus.configured': '已配置 {count} 个，共 {total} 个',
  'providerStatus.noModels': '无模型',
  'providerStatus.notConfigured': '未配置',
  'providerStatus.seeLess': '收起',
  'providerStatus.seeAll': '查看全部 {count} 个提供商',
  'providerStatus.learnMore': '了解如何配置提供商 →',
  'providerStatus.type.language': '语言',
  'providerStatus.type.embedding': '向量',
  'providerStatus.type.text_to_speech': '文本转语音',
  'providerStatus.type.speech_to_text': '语音转文本',
  'providerStatus.type.ocr': 'OCR',
  'providerStatus.type.image': '图片',
  'providerStatus.type.video': '视频',
  'providerStatus.type.music': '音乐',
  'providerStatus.type.3d': '3D 模型',
  'providerStatus.displayName.fishownapi': 'Fishown API（平台中转）',
  'providerStatus.displayName.ollama': 'Ollama',
  'providerStatus.displayName.openai': 'OpenAI',
  'providerStatus.displayName.google': 'Google Gemini',
  'providerStatus.displayName.anthropic': 'Anthropic Claude',
  'providerStatus.displayName.deepseek': 'DeepSeek',
  'providerStatus.displayName.minimax': 'MiniMax',
  'providerStatus.displayName.moonshot': '月之暗面',
  'providerStatus.displayName.alibaba': '阿里云百炼',
  'providerStatus.displayName.volcengine': '火山引擎',
  'providerStatus.displayName.glm': '智谱 GLM',
  'providerStatus.displayName.groq': 'Groq',
  'providerStatus.displayName.xai': 'xAI',
  'providerStatus.displayName.vertex': 'Vertex AI',
  'providerStatus.displayName.openrouter': 'OpenRouter',
  'providerStatus.displayName.elevenlabs': 'ElevenLabs',
  'providerStatus.displayName.voyage': 'Voyage',
  'providerStatus.displayName.azure': 'Azure OpenAI',
  'providerStatus.displayName.mistral': 'Mistral',
  'providerStatus.displayName.midjourney': 'Midjourney',
  'providerStatus.displayName.comfyui': 'ComfyUI',
  'providerStatus.displayName.openai-compatible': 'OpenAI 兼容',
  'providerStatus.displayName.openai_compatible': 'OpenAI 兼容',
}

const providerSettings = {
  'providerSettings.title': '配置 {provider}',
  'providerSettings.description': '输入 API 密钥和其他配置信息。',
  'providerSettings.placeholder': '输入 {key}',
  'providerSettings.noSettings': '此提供商无需配置。',
  'providerSettings.validation.required': '此项为必填。',
  'providerSettings.field.api_key': 'API Key',
  'providerSettings.field.base_url': '基础 URL',
  'providerSettings.field.timeout': '超时 (秒)',
  'providerSettings.field.max_tokens': '最大 Tokens',
  'providerSettings.field.temperature': '温度',
  'providerSettings.field.gemini_api_key': 'Gemini API Key',
  'providerSettings.field.project': '项目',
  'providerSettings.field.location': '位置',
  'providerSettings.field.credentials': '凭证 JSON 路径',
  'providerSettings.field.endpoint': '端点',
  'providerSettings.field.api_version': 'API 版本',
}

const modelTypeSection = {
  'modelTypeSection.languageModels.title': '语言模型',
  'modelTypeSection.languageModels.description': '对话、推理和文本生成',
  'modelTypeSection.embeddingModels.title': '嵌入模型',
  'modelTypeSection.embeddingModels.description': '语义搜索和向量嵌入',
  'modelTypeSection.textToSpeech.title': '文本转语音',
  'modelTypeSection.textToSpeech.description': '从文本生成音频',
  'modelTypeSection.speechToText.title': '语音转文本',
  'modelTypeSection.speechToText.description': '将音频转录为文本',
  'modelTypeSection.ocrModels.title': 'OCR 模型',
  'modelTypeSection.ocrModels.description': '光学字符识别',
  'modelTypeSection.imageModels.title': '图片模型',
  'modelTypeSection.imageModels.description': '图片生成和处理',
  'modelTypeSection.videoModels.title': '视频模型',
  'modelTypeSection.videoModels.description': '视频生成和处理',
  'modelTypeSection.musicModels.title': '音乐模型',
  'modelTypeSection.musicModels.description': '音乐生成和处理',
  'modelTypeSection.3dModels.title': '3D 模型',
  'modelTypeSection.3dModels.description': '3D 模型生成和处理',
  'modelTypeSection.filter.all': '全部',
  'modelTypeSection.noModels.configured': '未配置模型',
  'modelTypeSection.noModels.providerConfigured': '未配置 {provider} 模型',
  'modelTypeSection.noModels.badge': '无模型',
  'modelTypeSection.notConfigured.badge': '未配置',
  'modelTypeSection.showLess': '收起',
  'modelTypeSection.showMore': '显示另外 {count} 个',
  'modelTypeSection.deleteModel.title': '删除模型',
  'modelTypeSection.deleteModel.description': '确定要删除 “{name}” 吗？此操作无法撤消。',
  'modelTypeSection.deleteModel.confirm': '删除',
  'modelTypeSection.dimension': '维度: {dim}',
  'modelTypeSection.badge.systemModel': '系统模型',
  'modelTypeSection.badge.systemBilling': '系统计费',
  'modelTypeSection.tag.img_in': '支持图片输入',
  'modelTypeSection.tag.video_in': '支持视频输入',
  'modelTypeSection.capability.text_in': '文本输入',
  'modelTypeSection.capability.img_in': '图片输入',
  'modelTypeSection.capability.video_in': '视频输入',
  'modelTypeSection.capability.audio_in': '音频输入',
  'modelTypeSection.capability.function_calling': 'Function Call',
  'modelTypeSection.capability.deep_thinking': '深度思考',
  'modelTypeSection.capability.web_search': '联网搜索',
  'modelTypeSection.capability.structured_output': '结构化输出',
  'modelTypeSection.capability.text_out': '文本输出',
  'modelTypeSection.capability.img_out': '图片输出',
  'modelTypeSection.capability.video_out': '视频输出',
  'modelTypeSection.capability.audio_out': '音频输出',
  'modelTypeSection.capability.cache': '缓存',
  'modelTypeSection.capability.fine_tuning': '微调',
  'modelTypeSection.capability.batch_inference': '批量推理',
  'modelTypeSection.popover.modelId': '模型ID',
  'modelTypeSection.popover.introduction': '模型介绍',
  'modelTypeSection.popover.ioModality': '输入输出模态',
  'modelTypeSection.popover.capabilities': '模型能力',
  'modelTypeSection.popover.limits': '模型限制',
  'modelTypeSection.popover.contextWindow': '{val} 上下文窗口',
  'modelTypeSection.popover.maxInputTokens': '最大输入 {val}',
  'modelTypeSection.popover.maxOutputTokens': '最大输出 {val}',
  'modelTypeSection.popover.maxThinkingTokens': '最大思考 {val}',
  'modelTypeSection.popover.tpm': 'TPM {val}',
  'modelTypeSection.popover.rpm': 'RPM {val}',
  'modelTypeSection.popover.videoResolution': '分辨率: {val}',
  'modelTypeSection.popover.videoDuration': '时长: {val}-{val2}秒',
  'modelTypeSection.popover.videoFps': '帧率: {val} fps',
  'modelTypeSection.popover.watermark': '有水印',
  'modelTypeSection.popover.concurrency': '并发: {val}',
}

const modelPricing = {
  'modelPricing.buttonText': '模型定价',
  'modelPricing.title': '模型定价',
  'modelPricing.description': '平台系统模型的计费方式与价格详情',
  'modelPricing.empty': '暂无系统模型定价信息',
  'modelPricing.modelCount': '个模型',
  'modelPricing.input': '输入',
  'modelPricing.output': '输出',
  'modelPricing.perUse': '每次使用',
  'modelPricing.noDetail': '暂无详细定价信息',
  'modelPricing.noPricing': '暂无定价',
  'modelPricing.billingMode': '计费模式',
  'modelPricing.table.type': '类型',
  'modelPricing.table.price': '原价',
  'modelPricing.table.discountPrice': '折扣价',
}

const defaultModelsSection = {
  'defaultModelsSection.title': '默认模型分配',
  'defaultModelsSection.description': '配置 FishOwn Agent 中用于不同目的的 AI 模型',
  'defaultModelsSection.chatModel.label': '聊天模型',
  'defaultModelsSection.chatModel.description': '用于聊天对话',
  'defaultModelsSection.transformationModel.label': '转换模型',
  'defaultModelsSection.transformationModel.description': '用于摘要、洞察和转换',
  'defaultModelsSection.toolsModel.label': '多模态工具模型',
  'defaultModelsSection.toolsModel.description': '用于 function calling 和结构化信息提取 — 需支持视觉 + function calling',
  'defaultModelsSection.toolsModel.multimodalHint': '💡 创作提示词生成等场景需要同时具备图片理解（vision）和 function calling 能力。点击下方「推荐模型参考」查看更多。',
  'defaultModelsSection.largeContextModel.label': '大上下文模型',
  'defaultModelsSection.largeContextModel.description': '用于处理大型文档 - 推荐 Gemini',
  'defaultModelsSection.ocrModel.label': 'OCR 模型',
  'defaultModelsSection.ocrModel.description': '用于从图像和文档中提取文本',
  'defaultModelsSection.embeddingModel.label': '嵌入模型',
  'defaultModelsSection.embeddingModel.description': '用于语义搜索和向量嵌入',
  'defaultModelsSection.textToSpeechModel.label': '文本转语音模型',
  'defaultModelsSection.textToSpeechModel.description': '用于语音合成',
  'defaultModelsSection.speechToTextModel.label': '语音转文本模型',
  'defaultModelsSection.speechToTextModel.description': '用于音频转录',
  'defaultModelsSection.imageModel.label': '图片模型',
  'defaultModelsSection.imageModel.description': '用于图片生成和处理',
  'defaultModelsSection.3dModel.label': '3D 模型',
  'defaultModelsSection.3dModel.description': '用于 3D 模型生成和处理',
  'defaultModelsSection.missingRequired': '缺少必需模型：{models}。FishOwn Agent 可能无法正常运行。',
  'defaultModelsSection.selectModel.required': '⚠️ 必需 - 选择一个模型',
  'defaultModelsSection.selectModel.placeholder': '选择一个模型',
  'defaultModelsSection.option.systemModel': '系统模型',
  'defaultModelsSection.learnMore': '我应该选择哪个模型？→',
}

const addModelForm = {
  'addModelForm.button': '添加模型',
  'addModelForm.dialog.title': '添加 {type} 模型',
  'addModelForm.dialog.description': '从可用提供商配置新的 {type} 模型。',
  'addModelForm.noProviders': '没有可用于 {type} 模型的提供商',
  'addModelForm.embeddingDisabled': '嵌入模型由系统预置，暂不支持自定义添加',
  'addModelForm.provider.label': '提供商',
  'addModelForm.provider.placeholder': '选择一个提供商',
  'addModelForm.provider.required': '提供商是必需的',
  'addModelForm.name.label': '模型名称',
  'addModelForm.name.required': '模型名称是必需的',
  'addModelForm.name.placeholder.language': '例如：gpt-5-mini, claude, gemini',
  'addModelForm.name.placeholder.embedding': '例如：text-embedding-3-small',
  'addModelForm.name.placeholder.textToSpeech': '例如：tts-gpt-4o-mini-tts, tts-1-hd',
  'addModelForm.name.placeholder.speechToText': '例如：whisper-1',
  'addModelForm.name.placeholder.ocr': '例如：gpt-4-o, gemma2-9b-it',
  'addModelForm.name.placeholder.image': '例如：dall-e-3, stable-diffusion-xl',
  'addModelForm.name.placeholder.video': '例如：sora, runway-gen3',
  'addModelForm.name.placeholder.music': '例如：suno-v4, musicgen',
  'addModelForm.name.placeholder.3d': '例如：meshy-4, tripo3d',
  'addModelForm.name.placeholder.default': '输入模型名称',
  'addModelForm.name.azureHint': '对于 Azure，请使用部署名称作为模型名称',
  'addModelForm.actions.cancel': '取消',
  'addModelForm.actions.adding': '添加中...',
  'addModelForm.actions.addModel': '添加模型',
  'addModelForm.tags.label': '标签',
  'addModelForm.tags.placeholder': '输入标签，用逗号分隔',
  'addModelForm.tags.img_in': '图片输入',
  'addModelForm.tags.video_in': '视频输入',
  'addModelForm.tags.helpText': '标注模型特点（如：多模态模型、深度思考、视觉理解）',
  'addModelForm.tags.inputPlaceholder': '输入标签后按回车添加',
  'addModelForm.tags.presets': '快速添加：',
  'addModelForm.capabilities.label': '模型能力',
  'addModelForm.capabilities.modality.label': '输入/输出模态',
  'addModelForm.capabilities.modality.inputLabel': '输入模态',
  'addModelForm.capabilities.modality.outputLabel': '输出模态',
  'addModelForm.capabilities.modality.text_in': '文本输入',
  'addModelForm.capabilities.modality.img_in': '图片输入',
  'addModelForm.capabilities.modality.video_in': '视频输入',
  'addModelForm.capabilities.modality.audio_in': '音频输入',
  'addModelForm.capabilities.modality.text_out': '文本输出',
  'addModelForm.capabilities.modality.img_out': '图片输出',
  'addModelForm.capabilities.modality.video_out': '视频输出',
  'addModelForm.capabilities.modality.audio_out': '音频输出',
  'addModelForm.capabilities.features.label': '功能特性',
  'addModelForm.capabilities.features.function_calling': 'Function Call',
  'addModelForm.capabilities.features.structured_output': '结构化输出',
  'addModelForm.capabilities.features.deep_thinking': '深度思考',
  'addModelForm.capabilities.features.web_search': '联网搜索',
  'addModelForm.capabilities.features.cache': 'Cache 缓存',
  'addModelForm.capabilities.features.fine_tuning': '模型精调',
  'addModelForm.capabilities.features.batch_inference': '批量推理',
}

const embeddingModelChangeDialog = {
  'embeddingModelChangeDialog.title': '嵌入模型变更',
  'embeddingModelChangeDialog.description.intro': '你即将更改你的嵌入模型',
  'embeddingModelChangeDialog.description.fromTo': '从 <strong>{oldModelName}</strong> 到 <strong>{newModelName}</strong>',
  'embeddingModelChangeDialog.description.important': '重要：需要重建',
  'embeddingModelChangeDialog.description.rebuildWarning': '更改嵌入模型需要重建所有现有的嵌入以保持一致性。不重建，你的搜索可能会返回不正确或不完整的结果。',
  'embeddingModelChangeDialog.description.whatHappensNext': '接下来会发生什么：',
  'embeddingModelChangeDialog.description.updated': '你的默认嵌入模型将被更新',
  'embeddingModelChangeDialog.description.unchanged': '现有嵌入在重建前将保持不变',
  'embeddingModelChangeDialog.description.newContent': '新内容将使用新的嵌入模型',
  'embeddingModelChangeDialog.description.rebuildSoon': '你应该尽快重建嵌入',
  'embeddingModelChangeDialog.description.proceedQuestion': '你希望现在进入高级页面开始重建吗？',
  'embeddingModelChangeDialog.actions.cancel': '取消',
  'embeddingModelChangeDialog.actions.changeModelOnly': '仅更改模型',
  'embeddingModelChangeDialog.actions.changeAndRebuild': '更改并前往重建',
}



const digitalEmployeesPage = {
  'digital_employees.title': '手机员工',
  'digital_employees.description': '管理您的手机员工。',
  'digital_employees.view.table': '表格',
  'digital_employees.view.cards': '卡片',

  'digital_employees.table.empty': '暂无手机员工',
  'digital_employees.table.select_all': '全选',
  'digital_employees.table.select_row': '选择行',
  'digital_employees.table.serial': '设备序列号',
  'digital_employees.table.name': '名称',
  'digital_employees.table.login': '登录',
  'digital_employees.table.type': '业务类型',
  'digital_employees.table.mode': '设备模式',
  'digital_employees.table.available': '可用',
  'digital_employees.table.status': '状态',
  'digital_employees.table.expired_at': '过期时间',
  'digital_employees.table.control': '控制',

  'digital_employees.type.1': '小红书达人',
  'digital_employees.type.2': '视频号达人',
  'digital_employees.type.3': 'TK 达人',
  'digital_employees.type.4': '微信加好友',
  'digital_employees.type.5': '抖音 KOL',
  'digital_employees.type.12': '邮件群发',
  'digital_employees.type.14': 'BOSS 直聘',
  'digital_employees.type.16': '企微私域',
  'digital_employees.type.17': '千牛',
  'digital_employees.type.18': '个微云手机',
  'digital_employees.type.19': '小红书截流',

  'digital_employees.status.init': '初始化',
  'digital_employees.status.op_too_frequent': '操作过于频繁',
  'digital_employees.status.login': '已登录',
  'digital_employees.status.captcha': '验证码',
  'digital_employees.status.account_exception': '账号状态异常',
  'digital_employees.status.exception': '设备状态异常',
  'digital_employees.status.account_rest': '账号休息时间',
  'digital_employees.status.task': '任务中',
  'digital_employees.status.need_clear_data': '需要清理数据',
  'digital_employees.status.account_restricted': '账号被限制',
  'digital_employees.status.unknown': '未知状态',

  'digital_employees.login.yes': '已登录',
  'digital_employees.login.no': '未登录',
  'digital_employees.available.yes': '可用',
  'digital_employees.available.no': '不可用',
  'digital_employees.mode.otg': 'OTG',
  'digital_employees.mode.usb': 'USB',

  'digital_employees.action.mirror': '投屏',
  'digital_employees.action.remove': '移除',

  'digital_employees.batch.selected': '已选择 {count} 项',
  'digital_employees.batch.delete': '批量删除',
  'digital_employees.batch.delete_confirm_title': '确认批量删除？',
  'digital_employees.batch.delete_confirm_description': '即将删除 {count} 个手机员工，此操作不可撤销。',
  'digital_employees.refresh': '刷新',

  'digital_employees.filters.name_placeholder': '名称',
  'digital_employees.filters.status_placeholder': '状态',
  'digital_employees.filters.status_all': '全部状态',
  'digital_employees.filters.type_placeholder': '业务类型',
  'digital_employees.filters.type_all': '全部业务类型',


  'digital_employees.pagination.total': '共 {count} 个',
  'digital_employees.pagination.page_size': '每页数量',
  'digital_employees.pagination.per_page': '每页 {count} 个',
  'digital_employees.pagination.prev': '上一页',
  'digital_employees.pagination.next': '下一页',
  'digital_employees.pagination.page': '第 {page} / {total} 页',
  'digital_employees.add': '新增手机员工',
  'digital_employees.dialog.title': '新增手机员工',
  'digital_employees.dialog.title_edit': '更新设备',
  'digital_employees.dialog.description': '填写信息以添加新的手机员工。',
  'digital_employees.dialog.submit': '创建',
  'digital_employees.dialog.submit_update': '更新',
  'digital_employees.dialog.creating': '创建中…',
  'digital_employees.dialog.updating': '更新中…',
  'digital_employees.dialog.cancel': '取消',
  'digital_employees.dialog.fields.serial_number': '设备序列号',
  'digital_employees.dialog.fields.area': '设备区域',
  'digital_employees.dialog.fields.area_placeholder': '请选择设备区域',
  'digital_employees.dialog.fields.device_mode': '设备模式',
  'digital_employees.dialog.fields.device_mode_otg': 'OTG',
  'digital_employees.dialog.fields.device_mode_usb': 'USB',
  'digital_employees.dialog.fields.forward_port': '端口映射',
  'digital_employees.dialog.fields.remark': '备注',
  'digital_employees.dialog.fields.available': '设备是否可用',
  'digital_employees.dialog.fields.available_on': '可用',
  'digital_employees.dialog.fields.available_off': '不可用',
  'digital_employees.dialog.fields.tags': '标签',
  'digital_employees.dialog.fields.tags_placeholder': '用空格分隔，例如 测试 KOL',
  'digital_employees.toast.create_success': '手机员工创建成功',
  'digital_employees.toast.update_success': '设备更新成功',
  'digital_employees.toast.delete_success': '手机员工已移除',
  'digital_employees.toast.create_error': '创建手机员工失败',
  'digital_employees.toast.update_error': '更新设备失败',
  'digital_employees.toast.delete_error': '移除手机员工失败',
  'digital_employees.delete_confirm_title': '确认删除？',
  'digital_employees.delete_confirm_description': '即将永久删除 {name}（{id}），此操作不可撤回。',
}

const marketplacePage = {
  'marketplace.title': '应用市场',
  'marketplace.description': '管理您的应用。',
  'marketplace.searchPlaceholder': '搜索应用…',
  'marketplace.searchClear': '清空搜索',
  'marketplace.categoryPlaceholder': '分类',
  'marketplace.category.all': '全部分类',
  'marketplace.refresh': '刷新',
  'marketplace.retry': '重试',
  'marketplace.loadError.title': '加载应用失败',
  'marketplace.loadError.description': '请检查连接后重试。',
  'marketplace.empty.title': '暂无应用',
  'marketplace.empty.description': '可尝试调整搜索关键词或分类筛选。',
  'marketplace.premium': '精品应用',
  'marketplace.viewDetail': '查看详情',
  'marketplace.download': '下载',
  'marketplace.download.missing': '该应用暂不提供下载。',
  'marketplace.download.unsupported': '暂不支持当前平台的下载。',
  'marketplace.download.started': '开始下载',
  'marketplace.launch': '打开',
  'marketplace.login': '登录',
  'marketplace.goExternal': '跳转',
  'marketplace.launch.toast': '配置：{name}',
  'marketplace.details.summary': '简介',
  'marketplace.details.features': '功能亮点',

  'marketplace.category.AIGC': 'AIGC',
  'marketplace.category.KOL': 'KOL挖掘',
  'marketplace.category.Flow': '工作流',
  'marketplace.category.Shop': '电商工具',
  'marketplace.category.Common': '通用工具',
  'marketplace.category.quntool': '私域工具',

  'marketplace.plateType.AIGC': 'AIGC',
  'marketplace.plateType.KOL': 'KOL挖掘',
  'marketplace.plateType.Flow': '工作流',
  'marketplace.plateType.Shop': '电商工具',
  'marketplace.plateType.Common': '通用工具',
  'marketplace.plateType.quntool': '私域工具',

  'marketplace.plate.1': '拉新获客',
  'marketplace.plate.2': '私域运营',
}

const workflowsPage = {
  'workflows.title': '工作流',
  'workflows.description': '管理您的工作流。',
  'workflows.search.placeholder': '搜索所有工作流',
  'workflows.nav.backToAllGroups': '返回全部分组',
  'workflows.nav.addGroup': '新增分组',
  'workflows.nav.createWorkflow': '创建工作流',
  'workflows.section.myGroups': '我的分组',
  'workflows.empty.noGroups': '暂无分组',
  'workflows.empty.noGroupsDesc': '创建分组后可在此管理工作流',
  'workflows.empty.noWorkflows': '暂无工作流',
  'workflows.empty.noWorkflowsDesc': '创建新的工作流开始使用',
  'workflows.defaultGroup.title': '默认分组',
  'workflows.defaultGroup.desc': '展示未分组的工作流',
  'workflows.defaultName.group': '新建分组',
  'workflows.defaultName.workflow': '工作流',
  'workflows.toast.createGroupFailed': '创建分组失败',
  'workflows.toast.updateGroupFailed': '更新分组失败',
  'workflows.toast.emptyGroupSuccess': '解散成功',
  'workflows.toast.emptyGroupFailed': '解散分组失败',
  'workflows.toast.deleteGroupSuccess': '删除成功',
  'workflows.toast.deleteGroupFailed': '删除分组失败',
  'workflows.toast.createWorkflowFailed': '创建工作流失败',
  'workflows.toast.saveSuccess': '保存成功',
  'workflows.toast.saveFailed': '保存失败',
  'workflows.toast.lockedSuccess': '锁定成功',
  'workflows.toast.unlockedSuccess': '解锁成功',
  'workflows.toast.operationFailed': '操作失败',
  'workflows.toast.copySuccess': '复制成功',
  'workflows.toast.copyFailed': '复制失败',
  'workflows.toast.deleteSuccess': '删除成功',
  'workflows.toast.deleteFailed': '删除失败',
  'workflows.action.move': '移动到分组',
  'workflows.action.lock': '锁定',
  'workflows.action.unlock': '解锁',
  'workflows.action.editInfo': '编辑信息',
  'workflows.action.copy': '复制工作流',
  'workflows.action.delete': '删除工作流',
  'workflows.action.deleteGroup': '删除分组',
  'workflows.action.disbandGroup': '解散分组',
  'workflows.action.editWorkflow': '编辑工作流',
  'workflows.action.save': '保存',
  'workflows.action.saving': '保存中...',
  'workflows.action.cancel': '取消',
  'workflows.label.name': '工作流名称',
  'workflows.label.desc': '工作流描述（可选）',
  'workflows.label.group': '选择分组（可选）',
  'workflows.label.avatar': '工作流图标（可选）',
  'workflows.placeholder.input': '请输入',
  'workflows.placeholder.select': '请选择',
  'workflows.placeholder.avatarUrl': '请输入图标 URL',
  'workflows.unnamed': '未命名工作流',
  'workflows.noDescription': '暂无描述',
  'workflows.status.locked': '已锁定',
  'workflows.status.effective': '已生效',
  'workflows.status.ineffective': '未生效',
  'workflows.toast.nameRequired': '请输入工作流名称',
  'workflows.count': '{count} 个工作流',
  'workflows.group.default': '默认分组',
  'workflows.toast.moveFailed': '移动失败',
  'workflows.toast.moveSuccess': '移动成功',
  'workflows.confirm.emptyGroupTitle': '确认要解散该分组吗？',
  'workflows.confirm.emptyGroupDesc': '解散后，分组中的资源将归为未分组',
  'workflows.confirm.deleteGroupTitle': '确认要删除该分组吗？',
  'workflows.confirm.deleteGroupDesc': '删除后无法恢复，请谨慎操作！',
  'workflows.confirm.deleteWorkflowTitle': '确定删除当前工作流？',
  'workflows.confirm.deleteWorkflowDesc': '删除后，相关软件场景中的引用将变为无效。',
  'workflows.editor.backToList': '返回工作流列表',
  'workflows.editor.missingId': '缺少工作流 ID，无法打开',
}

const advancedPage = {
  'advanced.page.title': '高级',
  'advanced.page.description': '为高级用户提供的工具和实用程序',

  'advanced.rebuild.title': '重建向量',
  'advanced.rebuild.description': '为您的内容重建向量。在切换嵌入模型或修复损坏的向量时使用此功能。',
  'advanced.rebuild.mode.label': '重建模式',
  'advanced.rebuild.mode.existing.label': '仅限现有',
  'advanced.rebuild.mode.all.label': '全部',
  'advanced.rebuild.mode.existing.description': '重新嵌入已有向量的来源、笔记和见解；知识图谱实体会同时补齐缺失向量',
  'advanced.rebuild.mode.all.description': '重新嵌入现有项目 + 为没有向量的项目创建向量（速度较慢，更全面）',
  'advanced.rebuild.include.label': '重建范围',
  'advanced.rebuild.include.sources': '来源',
  'advanced.rebuild.include.notes': '笔记',
  'advanced.rebuild.include.insights': '见解',
  'advanced.rebuild.include.graph_entities': '知识图谱实体',
  'advanced.rebuild.include.error': '请至少选择一种要重建的项目类型',
  'advanced.rebuild.cta.loading': '正在开始重建...',
  'advanced.rebuild.cta.default': '开始重建',
  'advanced.rebuild.start_error': '启动重建失败：{message}',
  'advanced.rebuild.unknown_error': '未知错误',
  'advanced.rebuild.status.queued': '排队中',
  'advanced.rebuild.status.running': '运行中...',
  'advanced.rebuild.status.completed': '已完成！',
  'advanced.rebuild.status.failed': '失败',
  'advanced.rebuild.status.running_description': '您可离开此页面，重建将在后台运行',
  'advanced.rebuild.cta.new': '开始新的重建',
  'advanced.rebuild.progress.label': '进度',
  'advanced.rebuild.progress.stats': '{processed}/{total} 项 ({percent}%)',
  'advanced.rebuild.progress.failed': '⚠️ {count} 个项目处理失败',
  'advanced.rebuild.stats.time': '时间',
  'advanced.rebuild.stats.started': '开始于',
  'advanced.rebuild.stats.completed': '完成于',
  'advanced.rebuild.help.when.trigger': '我应该何时重建向量？',
  'advanced.rebuild.help.when.title': '您应该在以下情况重建向量：',
  'advanced.rebuild.help.when.item1.title': '切换嵌入模型时：',
  'advanced.rebuild.help.when.item1.description': '如果从一个嵌入模型切换到另一个，需要重建所有向量以确保一致性。',
  'advanced.rebuild.help.when.item2.title': '升级模型版本时：',
  'advanced.rebuild.help.when.item2.description': '更新到新版嵌入模型时，重建以利用改进。',
  'advanced.rebuild.help.when.item3.title': '修复损坏的向量时：',
  'advanced.rebuild.help.when.item3.description': '如果怀疑某些向量损坏或丢失，重建可以恢复它们。',
  'advanced.rebuild.help.when.item4.title': '批量导入后：',
  'advanced.rebuild.help.when.item4.description': '如果导入的内容没有向量，使用“全部”模式为所有内容嵌入向量。',
  'advanced.rebuild.help.time.trigger': '重建需要多长时间？',
  'advanced.rebuild.help.time.title': '处理时间取决于：',
  'advanced.rebuild.help.time.item1': '要处理的项目数量',
  'advanced.rebuild.help.time.item2': '嵌入模型速度',
  'advanced.rebuild.help.time.item3': 'API 速率限制（针对云提供商）',
  'advanced.rebuild.help.time.item4': '系统资源',
  'advanced.rebuild.help.time.rates_title': '典型速率：',
  'advanced.rebuild.help.time.rate1.title': '本地模型',
  'advanced.rebuild.help.time.rate1.description': '（Ollama）：非常快，仅受硬件限制',
  'advanced.rebuild.help.time.rate2.title': '云 API',
  'advanced.rebuild.help.time.rate2.description': '（OpenAI, Google）：速度适中，处理大数据集时可能达到速率限制',
  'advanced.rebuild.help.time.rate3.title': '来源：',
  'advanced.rebuild.help.time.rate3.description': '比笔记/见解慢（每个来源创建多个块）',
  'advanced.rebuild.help.time.example': '示例：使用云 API 重建 200 个项目可能需要 2-5 分钟，使用本地模型则不到 1 分钟。',
  'advanced.rebuild.help.safe.trigger': '在使用应用时重建是否安全？',
  'advanced.rebuild.help.safe.title': '是的，重建是安全的！',
  'advanced.rebuild.help.safe.item1.title': '是幂等的：',
  'advanced.rebuild.help.safe.item1.description': '多次运行产生相同结果',
  'advanced.rebuild.help.safe.item2.title': '不删除内容：',
  'advanced.rebuild.help.safe.item2.description': '仅替换向量',
  'advanced.rebuild.help.safe.item3.title': '可随时运行：',
  'advanced.rebuild.help.safe.item3.description': '无需停止其他操作',
  'advanced.rebuild.help.safe.item4.title': '优雅处理错误：',
  'advanced.rebuild.help.safe.item4.description': '失败的项目会被记录并跳过',
  'advanced.rebuild.help.safe.warning.title': '但是：',
  'advanced.rebuild.help.safe.warning.description': '非常大的重建（数千个项目）可能会在处理期间暂时减慢搜索速度。',

  'advanced.system_info.title': '系统信息',
  'advanced.system_info.loading': '加载中...',
  'advanced.system_info.current_version': '当前版本',
  'advanced.system_info.unknown': '未知',
  'advanced.system_info.latest_version': '最新版本',
  'advanced.system_info.status': '状态',
  'advanced.system_info.update_available': '有可用更新',
  'advanced.system_info.up_to_date': '已是最新',
  'advanced.system_info.view_on_website': '在官网上查看',
  'advanced.system_info.update_check_failed': '无法检查更新。更新服务器可能无法访问。',

  'advanced.desktop_runtime.title': '桌面运行时',
  'advanced.desktop_runtime.description': '管理本地桌面后端与 sidecar 服务',
  'advanced.desktop_runtime.backend': '后端进程',
  'advanced.desktop_runtime.runtime': 'Python 运行时',
  'advanced.desktop_runtime.sidecars': 'Sidecar 服务',
  'advanced.desktop_runtime.healthy': '健康',
  'advanced.desktop_runtime.unhealthy': '异常',
  'advanced.desktop_runtime.not_configured': '未配置',
  'advanced.desktop_runtime.pid': '进程号',
  'advanced.desktop_runtime.restart_backend': '重启后端',
  'advanced.desktop_runtime.start_runtime': '启动运行时',
  'advanced.desktop_runtime.stop_runtime': '停止运行时',
  'advanced.desktop_runtime.start_sidecars': '启动 Sidecar',
  'advanced.desktop_runtime.stop_sidecars': '停止 Sidecar',
  'advanced.desktop_runtime.diagnostics': '诊断',
  'advanced.desktop_runtime.export_diagnostics': '导出诊断',
  'advanced.desktop_runtime.exported_path': '导出文件',
  'advanced.desktop_runtime.total_errors': '错误总数',
  'advanced.desktop_runtime.fault.title': '检测到启动故障',
  'advanced.desktop_runtime.recheck': '重新检查',
  'advanced.desktop_runtime.error_code.BACKEND_START_FAILED': '后端启动失败',
  'advanced.desktop_runtime.error_code.RUNTIME_START_FAILED': '运行时启动失败',
  'advanced.desktop_runtime.error_code.SIDECAR_NOT_CONFIGURED': 'Sidecar 未配置',
  'advanced.desktop_runtime.error_code.PORT_CONFLICT': '端口冲突',
  'advanced.desktop_runtime.error_code.UNKNOWN': '未知错误',
  'advanced.desktop_runtime.error_hint.port_conflict.1': '本地必需端口可能已被其他进程占用。',
  'advanced.desktop_runtime.error_hint.port_conflict.2': '停止冲突进程或调整端口后重试启动。',
  'advanced.desktop_runtime.error_hint.backend_failed.1': '桌面 Python 后端启动失败或提前退出。',
  'advanced.desktop_runtime.error_hint.backend_failed.2': '请检查 Python 环境，并先导出诊断再重试。',
  'advanced.desktop_runtime.error_hint.runtime_failed.1': '运行时服务在超时时间内未达到健康状态。',
  'advanced.desktop_runtime.error_hint.runtime_failed.2': '请检查 sidecar 命令、日志和依赖，然后重启运行时。',
  'advanced.desktop_runtime.error_hint.sidecar_config.1': 'PostgreSQL/Redis sidecar 启动命令尚未配置。',
  'advanced.desktop_runtime.error_hint.sidecar_config.2': '请在桌面环境变量设置 DESKTOP_POSTGRES_COMMAND / DESKTOP_REDIS_COMMAND。',
  'advanced.desktop_runtime.error_hint.unknown.1': '检测到未知启动错误。',
  'advanced.desktop_runtime.error_hint.unknown.2': '请先导出诊断，并检查 runtime 与服务日志。',

  'advanced.jobs.title': '任务队列',
  'advanced.jobs.description': '监控后台任务和作业',
  'advanced.jobs.empty': '暂无任务',
  'advanced.jobs.columns.status': '状态',
  'advanced.jobs.columns.type': '类型',
  'advanced.jobs.columns.details': '详情',
  'advanced.jobs.columns.created': '创建时间',
  'advanced.jobs.columns.started': '开始时间',
  'advanced.jobs.columns.duration': '耗时',
  'advanced.jobs.total': '共 {count} 条',
  'advanced.jobs.columns.actions': '操作',
  'advanced.jobs.actions.retry': '重试',
  'advanced.jobs.actions.sourceDeleted': '文档已删除，无法重试',
  'advanced.jobs.status.new': '新建',
  'advanced.jobs.status.running': '运行中',
  'advanced.jobs.status.completed': '已完成',
  'advanced.jobs.status.failed': '失败',
  'advanced.jobs.status.canceled': '取消',
  'advanced.jobs.source_filter_placeholder': '按来源筛选',
  'advanced.jobs.all_sources': '全部来源',
}

const sourceCard = {
  'sourceCard.status.new.label': '新建',
  'sourceCard.status.new.description': '数据源已创建',
  'sourceCard.status.queued.label': '排队中',
  'sourceCard.status.queued.description': '等待处理',
  'sourceCard.status.running.label': '处理中',
  'sourceCard.status.running.description': '正在处理内容',
  'sourceCard.status.completed.label': '已完成',
  'sourceCard.status.completed.description': '处理完成',
  'sourceCard.status.failed.label': '失败',
  'sourceCard.status.failed.description': '处理失败',
  'sourceCard.untitled': '无标题数据源',
  'sourceCard.checking': '检查状态...',
  'sourceCard.type.link': '链接',
  'sourceCard.type.upload': '文件',
  'sourceCard.type.text': '文本',
  'sourceCard.type.unknown': '未知',
  'sourceCard.insights': '{count} 个洞见',
  'sourceCard.moreTopics': '+{count} 更多',
  'sourceCard.actions.removeFromNotebook': '从笔记本移除',
  'sourceCard.actions.retry': '重试处理',
  'sourceCard.actions.rebuildVectorFailed': '重建失败向量任务',
  'sourceCard.actions.rebuildGraphFailed': '重建失败图谱任务',
  'sourceCard.actions.delete': '删除数据源',
  'sourceCard.rebuild.vector.loading': '正在重建向量...',
  'sourceCard.rebuild.vector.success': '向量任务已重新构建',
  'sourceCard.rebuild.vector.error': '向量任务重建失败',
  'sourceCard.rebuild.graph.loading': '正在重建图谱...',
  'sourceCard.rebuild.graph.success': '图谱任务已重新构建',
  'sourceCard.rebuild.graph.error': '图谱任务重建失败',
  'sourceCard.progress': '向量索引构建进度',
  'sourceCard.embed': '嵌入',
  'sourceCard.graphrag': '图谱',
  'sourceCard.graphragProgress': '知识图谱索引构建进度',
}

const sourceDetail = {
  'sourceDetail.error.load': '加载数据源详情失败',
  'sourceDetail.success.insightCreated': '洞见创建成功',
  'sourceDetail.error.createInsight': '创建洞见失败',
  'sourceDetail.success.titleUpdated': '数据源标题已更新',
  'sourceDetail.error.updateTitle': '更新数据源标题失败',
  'sourceDetail.error.embed': '嵌入内容失败',
  'sourceDetail.success.downloadStarted': '下载已开始',
  'sourceDetail.error.fileUnavailable': '服务器上不再提供原始文件',
  'sourceDetail.error.download': '下载文件失败',
  'sourceDetail.success.urlCopied': 'URL 已复制到剪贴板',
  'sourceDetail.confirm.delete': '确定要删除此数据源吗？',
  'sourceDetail.success.delete': '数据源删除成功',
  'sourceDetail.error.delete': '删除数据源失败',
  'sourceDetail.notFound': '未找到数据源',
  'sourceDetail.title.placeholder': '数据源标题',
  'sourceDetail.title.untitled': '无标题数据源',
  'sourceDetail.sourceId': '数据源 ID: {id}',
  'sourceDetail.chat': '与数据源对话',
  'sourceDetail.file.unavailable': '文件不可用',
  'sourceDetail.file.preparing': '准备下载中…',
  'sourceDetail.file.download': '下载文件',
  'sourceDetail.embed.embedding': '正在构建向量索引...',
  'sourceDetail.embed.alreadyEmbedded': '已构建向量索引',
  'sourceDetail.embed.action': '构建向量索引',
  'sourceDetail.delete': '删除数据源',
  'sourceDetail.tabs.content': '内容',
  'sourceDetail.tabs.images': '图片',
  'sourceDetail.tabs.insights': '洞见',
  'sourceDetail.tabs.details': '详情',
  'sourceDetail.youtube.open': '在 YouTube 上打开',
  'sourceDetail.content.empty': '暂无内容',
  'sourceDetail.images.description': '从 PDF 等文件解析并上传到 COS 的图片',
  'sourceDetail.images.empty': '暂无解析图片',
  'sourceDetail.images.open': '打开',
  'sourceDetail.images.page': '页码',
  'sourceDetail.images.item': '图片',
  'sourceDetail.insights.description': '关于此数据源的 AI 生成洞见',
  'sourceDetail.insights.generate': '生成新洞见',
  'sourceDetail.insights.creating': '创建中...',
  'sourceDetail.insights.selectSkill': '选择一个技能...',
  'sourceDetail.error.selectSkill': '请选择一个技能',
  'sourceDetail.insights.create': '创建',
  'sourceDetail.insights.empty.title': '暂无洞见',
  'sourceDetail.insights.view': '查看洞见',
  'sourceDetail.insights.confirmDeleteTitle': '删除此洞见？',
  'sourceDetail.insights.confirmDeleteDescription': '此操作无法撤销，请确认。',
  'sourceDetail.alert.notEmbedded.title': '内容未索引',
  'sourceDetail.alert.notEmbedded.description': '此内容尚未构建向量索引。构建索引后可启用高级搜索功能和更好的内容发现。',
  'sourceDetail.alert.graphNotBuilt.title': '知识图谱未构建',
  'sourceDetail.alert.graphNotBuilt.description': '此内容尚未构建知识图谱（GraphRAG）。构建图谱可实现更深层次的实体关系分析和复杂问答。',
  'sourceDetail.graphrag.building': '正在构建...',
  'sourceDetail.graphrag.alreadyBuilt': '已构建',
  'sourceDetail.graphrag.action': '构建知识图谱',
  'sourceDetail.graphrag.progress': '图谱构建进度',
  'sourceDetail.graphrag.failed': '失败任务 {count} 个',
  'sourceDetail.error.buildGraph': '构建知识图谱失败',
  'sourceDetail.url': 'URL',
  'sourceDetail.uploadedFile': '已上传文件',
  'sourceDetail.file.unavailableButton': '不可用',
  'sourceDetail.file.preparingButton': '准备中…',
  'sourceDetail.file.downloadButton': '下载',
  'sourceDetail.file.unavailableDescription': '服务器上不再提供原始文件（可能在处理后已删除）。如果需要新副本，请再次上传。',
  'sourceDetail.topics': '主题',
  'sourceDetail.metadata': '元数据',
  'sourceDetail.metadata.embedded': '向量索引已构建',
  'sourceDetail.metadata.notEmbedded': '向量索引未构建',
  'sourceDetail.metadata.graphBuilt': '图谱已构建',
  'sourceDetail.metadata.graphNotBuilt': '图谱未构建',
  'sourceDetail.metadata.entityCount': '{count} 个实体',
  'sourceDetail.metadata.created': '创建于',
  'sourceDetail.metadata.updated': '更新于',
  'sourceDetail.type.unknown': '未知',
  'sourceDetail.type.link': '链接',
  'sourceDetail.type.file': '文件',
  'sourceDetail.type.text': '文本',
}

const streamingResponse = {
  'streamingResponse.error.notFound': '找不到此{type}',
  'streamingResponse.ariaLabel': '提问回答',
  'streamingResponse.strategy.title': '策略',
  'streamingResponse.strategy.reasoning': '推理：',
  'streamingResponse.strategy.searchTerms': '搜索词：',
  'streamingResponse.individualAnswers': '单独回答 ({count})',
  'streamingResponse.finalAnswer': '最终回答',
  'streamingResponse.processing': '正在处理您的问题...',
}

const advancedModelsDialog = {
  'advancedModelsDialog.title': '高级模型选择',
  'advancedModelsDialog.description': '为提问过程的每个阶段选择特定模型',
  'advancedModelsDialog.strategyModel.label': '策略模型',
  'advancedModelsDialog.strategyModel.placeholder': '选择策略模型',
  'advancedModelsDialog.answerModel.label': '回答模型',
  'advancedModelsDialog.answerModel.placeholder': '选择回答模型',
  'advancedModelsDialog.finalAnswerModel.label': '最终回答模型',
  'advancedModelsDialog.finalAnswerModel.placeholder': '选择最终回答模型',
  'advancedModelsDialog.cancel': '取消',
  'advancedModelsDialog.save': '保存更改',
}

const saveToNotebooksDialog = {
  'saveToNotebooksDialog.title': '保存到笔记本',
  'saveToNotebooksDialog.description': '选择一个或多个笔记本以保存此回答',
  'saveToNotebooksDialog.error.selectNotebook': '请至少选择一个笔记本',
  'saveToNotebooksDialog.success.saved': '回答已保存到 {count} 个笔记本',
  'saveToNotebooksDialog.error.saveFailed': '保存回答失败',
  'saveToNotebooksDialog.empty': '未找到笔记本。请先创建一个笔记本。',
  'saveToNotebooksDialog.cancel': '取消',
  'saveToNotebooksDialog.saving': '保存中...',
  'saveToNotebooksDialog.save': '保存到 {count} 个笔记本',
}

const modelsToast = {
  'models.toast.create.success.title': '成功',
  'models.toast.create.success.description': '模型创建成功',
  'models.toast.create.success.description_with_dim': '模型创建成功 (探测到向量维度: {dim})',
  'models.toast.create.error.title': '错误',
  'models.toast.create.error.description': '创建模型失败',
  'models.toast.delete.success.title': '成功',
  'models.toast.delete.success.description': '模型删除成功',
  'models.toast.delete.error.title': '错误',
  'models.toast.delete.error.description': '删除模型失败',
  'models.toast.updateDefaults.success.title': '成功',
  'models.toast.updateDefaults.success.description': '默认模型更新成功',
  'models.toast.updateDefaults.error.title': '错误',
  'models.toast.updateDefaults.error.description': '更新默认模型失败',
  'models.toast.updateProviderSettings.success.title': '成功',
  'models.toast.updateProviderSettings.success.description': '提供商设置更新成功',
  'models.toast.updateProviderSettings.error.title': '错误',
  'models.toast.updateProviderSettings.error.description': '更新提供商设置失败',
}

const xhsqunToast = {
  'xhsqun.autojoin.toast.selectWorkflow': '请选择工作流',
  'xhsqun.autojoin.toast.invalidDailyJoinLimit': '每日加群初始下限不能等于大于最终上限',
  'xhsqun.autojoin.toast.saveFailed': '保存失败',
  'xhsqun.autojoin.toast.selectDeviceGroup': '请选择设备分组',
  'xhsqun.autojoin.toast.saveSuccess': '保存成功',
  'xhsqun.autojoin.toast.operationFailed': '操作失败',
  'xhsqun.autojoin.toast.deviceIdCopied': '已复制设备ID',
  'xhsqun.autojoin.toast.copyFailed': '复制失败',
  'xhsqun.autojoin.toast.invalidGroupSizeLimit': '群人数下限不能等于大于上限',
  'xhsqun.autojoin.toast.stopSuccess': '停止任务成功',
  'xhsqun.autojoin.toast.startSuccess': '启动任务成功',
  'xhsqun.autojoin.toast.loadFailed': '加载失败',
  'xhsqun.autojoin.toast.operationSuccess': '操作成功',
}

const dykolToast = {
  'dykol.deviceGroups.toast.createSuccess': '创建成功',
  'dykol.deviceGroups.toast.createFailed': '创建失败',
  'dykol.deviceGroups.toast.updateSuccess': '更新成功',
  'dykol.deviceGroups.toast.updateFailed': '更新失败',
  'dykol.deviceGroups.toast.deleteSuccess': '删除成功',
  'dykol.deviceGroups.toast.deleteFailed': '删除失败',
  'dykol.deviceGroups.toast.enterGroupName': '请输入分组名称',
  'dykol.task.toast.createSuccess': '任务创建成功',
  'dykol.task.toast.createFailed': '创建失败',
}

const xhsqunPrivateToast = {
  'xhsqun.private.toast.saveSuccess': '保存成功',
  'xhsqun.private.toast.saveFailed': '保存失败',
  'xhsqun.private.toast.selectWorkflow': '请选择工作流',
  'xhsqun.private.toast.loadFailed': '加载失败',
  'xhsqun.private.toast.operationFailed': '操作失败',
  'xhsqun.private.toast.paused': '已暂停',
  'xhsqun.private.toast.resumed': '已恢复',
  'xhsqun.private.toast.deviceIdCopied': '已复制设备ID',
  'xhsqun.private.toast.copyFailed': '复制失败',
}

const emailTemplateToast = {
  'email.template.toast.deleteSuccess': '删除成功',
  'email.template.toast.deleteFailed': '删除失败',
  'email.template.toast.createHint': '模版创建页尚未迁移，请暂时在旧系统创建。',
  'email.template.toast.editHint': '模版编辑页尚未迁移，请暂时在旧系统编辑。',
}

const emailRenewToast = {
  'email.renew.toast.purchaseSuccess': '购买成功',
  'email.renew.toast.purchaseFailed': '购买失败',
  'email.renew.toast.statusUpdateSuccess': '修改状态成功',
  'email.renew.toast.statusUpdateFailed': '修改状态失败',
  'email.renew.toast.enterSearchKeyword': '请输入搜索关键词',
  'email.renew.toast.searchFailed': '搜索失败',
  'email.renew.toast.selectDomain': '请选择要购买的域名',
  'email.renew.toast.rechargeHint': '充值入口尚未迁移，请前往旧系统。',
  'email.renew.toast.enterPurchaseQuantity': '购买数量不能为空',
}

const gnkeyToast = {
  'gnkey.page.toast.loadFailed': '加载失败',
  'gnkey.page.toast.deleteSuccess': '删除成功',
  'gnkey.page.toast.deleteFailed': '删除失败',
  'gnkey.create.toast.openSuccess': '开通成功',
  'gnkey.create.toast.openFailed': '开通失败',
  'gnkey.create.toast.noSceneId': '未返回 sceneId',
}

const emailCustomerToast = {
  'email.customer.toast.addSuccess': '添加成功',
  'email.customer.toast.addFailed': '添加失败',
  'email.customer.toast.updateSuccess': '修改成功',
  'email.customer.toast.updateFailed': '修改失败',
  'email.customer.toast.deleteSuccess': '删除成功',
  'email.customer.toast.deleteFailed': '删除失败',
  'email.customer.toast.cleanSuccess': '邮箱清洗成功',
  'email.customer.toast.cleanFailed': '邮箱清洗失败',
  'email.customer.toast.importSuccess': '导入成功',
  'email.customer.toast.importFailed': '导入失败',
  'email.customer.toast.enterName': '请输入名称',
  'email.customer.toast.selectFile': '请选择上传文件',
  'email.customer.toast.noEmailsToClean': '当前表单内暂无需要清洗的邮箱。',
  'email.customer.toast.insufficientQuota': '清洗额度不足，请前往续费管理购买。',
  'email.customer.toast.createTaskHint': '任务创建页尚未迁移，请暂时在旧系统创建。',
}

const emailTaskToast = {
  'email.task.toast.info': '提示信息',
  'email.task.toast.updateFailed': '更新失败',
  'email.task.toast.deleteSuccess': '删除成功',
  'email.task.toast.deleteFailed': '删除失败',
  'email.task.toast.createHint': '任务创建页尚未迁移，请暂时在旧系统创建。',
  'email.task.toast.detailHint': '任务详情页尚未迁移，请暂时在旧系统查看。',
  'email.task.toast.editHint': '任务编辑页尚未迁移，请暂时在旧系统编辑。',
}

const workflowsToast = {
  'workflows.toast.createGroupFailed': '创建分组失败',
  'workflows.toast.updateGroupFailed': '更新分组失败',
  'workflows.toast.emptyGroupSuccess': '解散成功',
  'workflows.toast.emptyGroupFailed': '解散分组失败',
  'workflows.toast.deleteGroupSuccess': '删除成功',
  'workflows.toast.deleteGroupFailed': '删除分组失败',
  'workflows.toast.createWorkflowFailed': '创建工作流失败',
  'workflows.toast.saveSuccess': '保存成功',
  'workflows.toast.saveFailed': '保存失败',
  'workflows.toast.lockedSuccess': '锁定成功',
  'workflows.toast.unlockedSuccess': '解锁成功',
  'workflows.toast.operationFailed': '操作失败',
  'workflows.toast.copySuccess': '复制成功',
  'workflows.toast.copyFailed': '复制失败',
  'workflows.toast.deleteSuccess': '删除成功',
  'workflows.toast.deleteFailed': '删除失败',
  'workflows.toast.moveFailed': '移动失败',
  'workflows.toast.moveSuccess': '移动成功',
}

const gzhkolMonitorToast = {
  'gzhkol.monitor.toast.loadFailed': '加载失败',
  'gzhkol.monitor.toast.operationSuccess': '操作成功',
  'gzhkol.monitor.toast.operationFailed': '操作失败',
}

const gzhkolResourceToast = {
  'gzhkol.resource.toast.operationSuccess': '操作成功',
  'gzhkol.resource.toast.operationFailed': '操作失败',
  'gzhkol.resource.toast.updateSuccess': '修改成功',
  'gzhkol.resource.toast.updateFailed': '修改失败',
  'gzhkol.resource.checkLink.toast.loadFailed': '加载失败',
}

const dykolTask = {
  'dykol.task.status.pending': '待执行',
  'dykol.task.status.running': '进行中...',
  'dykol.task.status.completed': '已完成',
  'dykol.task.status.paused': '已暂停',
  'dykol.task.time.justNow': '刚刚',
  'dykol.task.time.minutesAgo': '{minutes}分钟前',
  'dykol.task.time.minutesLater': '{minutes}分钟后',
  'dykol.task.time.hoursAgo': '{hours}小时前',
  'dykol.task.time.hoursLater': '{hours}小时后',
  'dykol.task.time.daysAgo': '{days}天前',
  'dykol.task.time.daysLater': '{days}天后',
  'dykol.task.create.title': '创建任务',
  'dykol.task.create.wizard': '任务向导',
  'dykol.task.statistic.title': '任务统计',
  'dykol.task.statistic.totalMatched': '历史入库人数',
  'dykol.task.statistic.todayMatched': '今日入库人数',
  'dykol.task.statistic.lastUpdated': '最近一次更新时间',
  'dykol.task.statistic.matchRate': '入库率',
  'dykol.task.unit.person': '人',
  'dykol.task.list.title': '挖掘任务',
  'dykol.task.list.count': '当前任务数 {count}',
  'dykol.task.search.placeholder': '搜索任务名称',
  'dykol.task.filter.status': '任务状态',
  'dykol.task.filter.all': '全部状态',
  'dykol.task.filter.pending': '待执行',
  'dykol.task.filter.running': '进行中',
  'dykol.task.filter.completed': '已完成',
  'dykol.task.filter.paused': '已暂停',
  'dykol.task.filter.clear': '清空',
  'dykol.task.list.loading': '加载中...',
  'dykol.task.list.empty': '暂无任务',
  'dykol.task.list.loadingMore': '加载更多...',
  'dykol.task.list.noMore': '没有更多了',
  'dykol.task.toast.loadFailed': '加载失败',
  'dykol.task.toast.deleteSuccess': '删除成功',
  'dykol.task.toast.pauseSuccess': '暂停成功',
  'dykol.task.toast.resumeSuccess': '恢复成功',
  'dykol.task.toast.operationFailed': '操作失败',
  'dykol.task.action.delete': '删除',
  'dykol.task.action.pause': '暂停',
  'dykol.task.action.resume': '恢复',
  'dykol.task.confirm.deleteDescription': '删除后无法恢复，请谨慎操作。',
  'dykol.task.confirm.actionDescription': '确定{action}当前任务？',
  'dykol.task.card.status': '状态：{status}',
  'dykol.task.card.devices': '使用{count}台设备',
  'dykol.task.card.lastMatched': '最近入库：{time}',
  'dykol.task.card.actions': '操作',
  'dykol.task.card.resumeTask': '恢复任务',
  'dykol.task.card.pauseTask': '暂停任务',
  'dykol.task.card.deleteTask': '删除任务',
  'dykol.task.card.progress': '进度',
  'dykol.task.card.matchedCount': '入库人数',
  'dykol.task.card.collectedCount': '已采集人数',
  'dykol.task.confirm.title': '确认{action}',
}

const notebooksToast = {
  'notebooks.toast.create.success.title': '成功',
  'notebooks.toast.create.success.description': '笔记本创建成功',
  'notebooks.toast.create.error.title': '错误',
  'notebooks.toast.create.error.description': '创建笔记本失败',
  'notebooks.toast.update.success.title': '成功',
  'notebooks.toast.update.success.description': '笔记本更新成功',
  'notebooks.toast.update.error.title': '错误',
  'notebooks.toast.update.error.description': '更新笔记本失败',
  'notebooks.toast.delete.success.title': '成功',
  'notebooks.toast.delete.success.description': '笔记本删除成功',
  'notebooks.toast.delete.error.title': '错误',
  'notebooks.toast.delete.error.description': '删除笔记本失败',
}

const emailTaskPage = {
  'email.task.stats.totalSend': '累计投送',
  'email.task.stats.todaySend': '今日投送',
  'email.task.stats.todaySuccess': '今日触达数量',
  'email.task.stats.totalClick': '今日点击数量',
  'email.task.stats.unit': '人',
  'email.task.create.title': '创建任务',
  'email.task.create.button': '立即创建任务',
  'email.task.create.toast.title': '提示',
  'email.task.stats.title': '任务统计',
  'email.task.list.title': '任务列表',
  'email.task.list.total': '共 {count} 条',
  'email.task.filter.status.placeholder': '任务状态',
  'email.task.filter.status.all': '全部状态',
  'email.task.filter.search.placeholder': '搜索任务名称',
  'email.task.filter.clear': '清空',
  'email.task.list.loading': '加载中...',
  'email.task.list.empty': '暂无任务',
  'email.task.list.header.name': '任务名称',
  'email.task.list.header.status': '运行状态',
  'email.task.list.header.totalEmail': '邮箱总数',
  'email.task.list.header.cleanRate': '清洗成功率',
  'email.task.list.header.sendProgress': '投送进度',
  'email.task.list.header.metrics': '触达/阅读/点击',
  'email.task.list.header.createdAt': '创建时间',
  'email.task.list.header.actions': '操作',
  'email.task.metrics.reach': '触达',
  'email.task.metrics.read': '阅读',
  'email.task.metrics.click': '点击',
  'email.task.delete.title': '删除任务',
  'email.task.delete.description': '任务名称《{name}》，删除后无法恢复，请谨慎操作。',
  'email.task.delete.confirm': '删除',
}

const notesToast = {
  'notes.toast.create.success.title': '成功',
  'notes.toast.create.success.description': '笔记创建成功',
  'notes.toast.create.error.title': '错误',
  'notes.toast.create.error.description': '创建笔记失败',
  'notes.toast.update.success.title': '成功',
  'notes.toast.update.success.description': '笔记更新成功',
  'notes.toast.update.error.title': '错误',
  'notes.toast.update.error.description': '更新笔记失败',
  'notes.toast.delete.success.title': '成功',
  'notes.toast.delete.success.description': '笔记删除成功',
  'notes.toast.delete.error.title': '错误',
  'notes.toast.delete.error.description': '删除笔记失败',
}


const searchToast = {
  'search.toast.error.title': '搜索失败',
  'search.toast.error.description': '搜索时发生错误',
}

const settingsToast = {
  'settings.toast.update.success.title': '成功',
  'settings.toast.update.success.description': '设置更新成功',
  'settings.toast.update.error.title': '错误',
  'settings.toast.update.error.description': '更新设置失败',
}

const sourcesToast = {
  'sources.toast.create.queued.title': '来源已排队',
  'sources.toast.create.queued.description': '来源已提交后台处理。您可以在来源列表中监控进度。',
  'sources.toast.create.success.title': '成功',
  'sources.toast.create.success.description': '来源添加成功',
  'sources.toast.create.error.title': '错误',
  'sources.toast.create.error.description': '添加来源失败',
  'sources.toast.update.success.title': '成功',
  'sources.toast.update.success.description': '来源更新成功',
  'sources.toast.update.error.title': '错误',
  'sources.toast.update.error.description': '更新来源失败',
  'sources.toast.delete.success.title': '成功',
  'sources.toast.delete.success.description': '来源删除成功',
  'sources.toast.delete.error.title': '错误',
  'sources.toast.delete.error.description': '删除来源失败',
  'sources.toast.upload.success.title': '成功',
  'sources.toast.upload.success.description': '文件上传成功',
  'sources.toast.upload.error.title': '错误',
  'sources.toast.upload.error.description': '文件上传失败',
  'sources.toast.retry.success.title': '来源重试已排队',
  'sources.toast.retry.success.description': '来源已重新加入处理队列。',
  'sources.toast.retry.error.title': '重试失败',
  'sources.toast.retry.error.description': '无法重试来源处理。请重试。',
  'sources.toast.addToNotebook.success.title': '成功',
  'sources.toast.addToNotebook.success.description': '已将 {count} 个来源添加到笔记本',
  'sources.toast.addToNotebook.error.title': '错误',
  'sources.toast.addToNotebook.error.description': '无法将来源添加到笔记本',
  'sources.toast.addToNotebook.partial.title': '部分成功',
  'sources.toast.addToNotebook.partial.description': '已添加 {successes} 个来源，{failures} 个失败',
  'sources.toast.removeFromNotebook.success.title': '成功',
  'sources.toast.removeFromNotebook.success.description': '已成功从笔记本移除来源',
  'sources.toast.removeFromNotebook.error.title': '错误',
  'sources.toast.removeFromNotebook.error.description': '无法从笔记本移除来源',
}


const versionCheckToast = {
  'versionCheck.toast.available.title': '版本 {version} 可用',
  'versionCheck.toast.available.description': 'FishOwn Agent 有新版本可用。',
  'versionCheck.toast.available.action': '在 GitHub 上查看',
}

const chatToast = {
  'chat.toast.createSession.success': '对话会话已创建',
  'chat.toast.createSession.error': '创建对话会话失败',
  'chat.toast.updateSession.success': '会话已更新',
  'chat.toast.updateSession.error': '更新会话失败',
  'chat.toast.deleteSession.success': '会话已删除',
  'chat.toast.deleteSession.error': '删除会话失败',
  'chat.toast.sendMessage.error': '发送消息失败',
}

const commonToast = {
  'common.toast.error': '错误',
  'common.toast.success': '成功',
}

// Skills page
const skillsPage = {
  'skills.title': '插件与技能',
  'skills.subtitle': '管理插件与技能。',
  'skills.tabPlugins': '插件',
  'skills.tabSkills': '技能',
  'skills.tabPlayground': '体验区',
  'skills.playground.title': '技能体验区',
  'skills.playground.description': '与技能对话，测试和体验效果。',
  'skills.playground.skill_label': '技能',
  'skills.playground.skill_placeholder': '选择一个技能',
  'skills.playground.model_label': '模型',
  'skills.playground.model_placeholder': '选择一个模型',
  'skills.playground.input_placeholder': '输入消息...',
  'skills.playground.send': '发送',
  'skills.playground.running': '正在执行 {skill}...',
  'skills.playground.no_skills': '没有可用的技能。',
  'skills.playground.toast.error.title': '体验区错误',
  'skills.playground.toast.error.description': '技能执行失败。',
  'skills.filter': '筛选',
  'skills.searchPlaceholder': '搜索技能',
  'skills.showing': '显示 {count} 项',
  'skills.refresh': '刷新',
  'skills.bundled': '系统',
  'skills.loadError.title': '加载技能失败',
  'skills.loadError.description': '发生错误，无法从服务器检索技能列表。',
  'skills.retry': '重试',
  'skills.empty.title': '未找到技能。',
  'skills.empty.description': '请检查配置或稍后重试。',
  'skills.empty.search': '未找到匹配的技能。',
  'skills.source.bundled': '内置',
  'skills.source.hosted': '托管',
  'skills.source.workspace': '工作区',
  'skills.actions.enable': '启用',
  'skills.actions.disable': '禁用',
  'skills.card.noDescription': '暂无描述',
  'skills.browseStore': '浏览技能商店',
  'skills.groups.workspace': '工作区技能',
  'skills.groups.builtIn': '内置技能',
  'skills.groups.installed': '已安装技能',
  'skills.groups.extra': '额外技能',
  'skills.groups.other': '其他技能',
  'skills.status.bundled': '内置',
  'skills.status.eligible': '已启用',
  'skills.status.blocked': '被阻止',
  'skills.status.disabled': '已禁用',
  'skills.status.blockedByAllowlist': '被白名单阻止',
  'skills.card.missing': '缺失: {reasons}',
  'skills.card.reason': '原因: {reasons}',
  'skills.actions.saveKey': '保存密钥',
  'skills.apiKey': 'API 密钥',
  'skills.installing': '安装中…',

  // ── Workspace (SkillsWorkspace) ──
  'skills.workspace.title': '技能',
  'skills.workspace.availableCount': '{count} 个可用',
  'skills.workspace.filterPlaceholder': '筛选技能',
  'skills.workspace.noMatch': '无匹配技能',
  'skills.workspace.emptyTitle': '无技能',
  'skills.workspace.emptyDesc': '创建或导入技能以查看其文件。',
  'skills.workspace.selectFile': '选择一个文件查看。',
  'skills.workspace.never': '从未',

  // Import
  'skills.workspace.importPlaceholder': '粘贴路径、GitHub URL 或 skills.sh 命令',
  'skills.workspace.importAdd': '导入',
  'skills.workspace.importSuccess_one': '导入了 1 个技能',
  'skills.workspace.importSuccess_other': '导入了 {count} 个技能',
  'skills.workspace.importFailed': '技能导入失败',

  // Source help dialog
  'skills.workspace.sourceHelpTitle': '添加技能源',
  'skills.workspace.sourceHelpDesc': '请先粘贴本地路径、GitHub URL 或 skills.sh 命令。',
  'skills.workspace.browseSkillsSh': '浏览 skills.sh',
  'skills.workspace.browseSkillsShDesc': '查找安装命令并粘贴到此处。',
  'skills.workspace.browseSkillHub': '浏览 SkillHub',
  'skills.workspace.browseSkillHubDesc': '访问 skillhub.cn 技能商店，查找安装命令并粘贴到此处。',
  'skills.workspace.searchGithub': '搜索 GitHub',
  'skills.workspace.searchGithubDesc': '查找包含 SKILL.md 的仓库，然后粘贴仓库 URL 到此处。',

  // Delete dialog
  'skills.workspace.deleteTitle': '移除技能',
  'skills.workspace.deleteDesc': '从库中移除此技能。若有代理仍在使用，将阻止移除。',
  'skills.workspace.deleteConfirm': '即将移除 {name}。',
  'skills.workspace.deleteConfirmGeneric': '即将移除此技能。',
  'skills.workspace.deleteUsedBy': '当前被 {agents} 使用。',
  'skills.workspace.deleteBlocked': '请先从所有代理中解除此技能以启用移除。',
  'skills.workspace.deleteButton': '移除技能',
  'skills.workspace.deleting': '移除中…',

  // Detail header
  'skills.workspace.playground': '体验',
  'skills.workspace.edit': '编辑',
  'skills.workspace.stopEdit': '停止编辑',
  'skills.workspace.remove': '移除',
  'skills.workspace.sourceLabel': '来源',
  'skills.workspace.pinLabel': 'Pin',
  'skills.workspace.keyLabel': 'Key',
  'skills.workspace.updatedLabel': '更新于',
  'skills.workspace.usedByLabel': '被使用',
  'skills.workspace.untracked': '未跟踪',
  'skills.workspace.tracking': '跟踪 {ref}',

  // Update
  'skills.workspace.checkUpdates': '检查更新',
  'skills.workspace.installUpdate': '安装更新',
  'skills.workspace.upToDate': '已是最新',
  'skills.workspace.updateSuccess': '已更新至 {ref}',
  'skills.workspace.updateSuccessGeneric': '技能已更新',
  'skills.workspace.updateFailed': '更新失败',

  // Restore defaults
  'skills.workspace.restoreDefaults': '恢复默认技能',
  'skills.workspace.restoreSuccess': '已恢复 {count} 个默认技能',
  'skills.workspace.restoreUpToDate': '默认技能已是最新',
  'skills.workspace.restoreFailed': '恢复默认技能失败',
  'skills.workspace.bundledEditHint': '系统默认技能不可编辑，如需修改请先复制',
  'skills.workspace.bundledDeleteHint': '系统默认技能不可删除',

  // Source copy
  'skills.workspace.copySourcePath': '复制源路径',
  'skills.workspace.copiedSourcePath': '已复制源路径',

  // Toasts
  'skills.workspace.toast.created': '技能已创建',
  'skills.workspace.toast.createFailed': '创建技能失败',
  'skills.workspace.toast.saved': '技能已保存',
  'skills.workspace.toast.saveFailed': '保存失败',
  'skills.workspace.toast.removed': '技能已移除',
  'skills.workspace.toast.removeFailed': '移除失败',

  // File toolbar
  'skills.workspace.fileView': '预览',
  'skills.workspace.fileCode': '代码',

  // New skill form
  'skills.workspace.newSkill.namePlaceholder': '技能名称',
  'skills.workspace.newSkill.slugPlaceholder': '可选简称',
  'skills.workspace.newSkill.descPlaceholder': '简短描述',
  'skills.workspace.newSkill.creating': '创建中…',
  'skills.workspace.newSkill.createButton': '创建技能',

  // Source type labels
  'skills.source.github': 'GitHub',
  'skills.source.url': 'URL',
  'skills.source.local': '本地路径',
  'skills.source.database': '数据库',
  'skills.source.githubManaged': 'GitHub 管理',
  'skills.source.urlManaged': 'URL 管理',
  'skills.source.localManaged': '本地管理',
  'skills.source.databaseManaged': '数据库管理',
  'skills.source.skillsShManaged': 'skills.sh 管理',

  // ── Name translations for system/bundled skills (keyed by skillKey or key) ──
  // When no entry exists, the raw backend name is used as fallback.
  'skills.name.analyze-paper': '论文分析',
  'skills.name.key-insights': '关键洞见',
  'skills.name.dense-summary': '稠密摘要',
  'skills.name.reflection-questions': '反思追问',
  'skills.name.outline-topics': '主题大纲',
  'skills.name.brief-summary': '简要摘要',
  'skills.name.summarize-sources': '综合汇总',
  'skills.name.compare-sources': '对比分析',
  'skills.name.extract-evidence': '证据提取',
  'skills.name.draft-from-sources': '来源起草',
  'skills.name.extract-action-items': '行动项提取',
  'skills.name.polish-writing': '润色写作',
  'skills.name.build-study-guide': '学习指南',
  'skills.name.create-quiz': '生成测验',

  // Plugin-prefixed keys (if backend sends e.g. "source-transformations/analyze-paper")
  'skills.name.source-transformations/analyze-paper': '论文分析',
  'skills.name.source-transformations/key-insights': '关键洞见',
  'skills.name.source-transformations/dense-summary': '稠密摘要',
  'skills.name.source-transformations/reflection-questions': '反思追问',
  'skills.name.source-transformations/outline-topics': '主题大纲',
  'skills.name.source-transformations/brief-summary': '简要摘要',
  'skills.name.knowledge-research/summarize-sources': '综合汇总',
  'skills.name.knowledge-research/compare-sources': '对比分析',
  'skills.name.knowledge-research/extract-evidence': '证据提取',
  'skills.name.content-workflow/draft-from-sources': '来源起草',
  'skills.name.content-workflow/extract-action-items': '行动项提取',
  'skills.name.content-workflow/polish-writing': '润色写作',
  'skills.name.learning-assistant/build-study-guide': '学习指南',
  'skills.name.learning-assistant/create-quiz': '生成测验',
}

const pluginsPage = {
  // Workspace sidebar
  'plugins.workspace.title': '插件',
  'plugins.availableCount': '{count} 个可用',
  'plugins.filterPlaceholder': '筛选插件',
  'plugins.empty': '暂无已安装的插件。粘贴路径导入一个。',
  'plugins.emptyTitle': '未选择插件',
  'plugins.emptyDesc': '从左侧列表选择一个插件查看详情，或导入一个新插件。',
  'plugins.noMatch': '无匹配插件',

  // Import
  'plugins.importPlaceholder': '输入绝对路径或 https://…/plugin.zip',
  'plugins.inspect': '检查',
  'plugins.inspectFailed': '插件检查失败',
  'plugins.capabilities': '权限',
  'plugins.none': '无',
  'plugins.confirmInstall': '确认安装',
  'plugins.installed': '插件已安装',
  'plugins.installFailed': '插件安装失败',

  // Review
  'plugins.reviewApprove': '审核并批准',
  'plugins.reviewApproved': '已批准此版本的运行时权限',

  // Update
  'plugins.checkUpdate': '检查更新',
  'plugins.upToDate': '已是最新版本',
  'plugins.updateInstalled': '更新已安装，审核后启用',
  'plugins.updateFailed': '更新失败',

  // Enable/Disable
  'plugins.enable': '启用',
  'plugins.disable': '禁用',
  'plugins.enabled': '已启用',
  'plugins.disabled': '已禁用',

  // Uninstall
  'plugins.uninstall': '卸载',
  'plugins.uninstallTitle': '卸载插件',
  'plugins.uninstallDesc': '从系统中移除此插件。此操作不可逆。',
  'plugins.uninstallConfirm': '即将卸载 {name}。',
  'plugins.uninstallConfirmGeneric': '即将卸载此插件。',
  'plugins.uninstalling': '卸载中…',
  'plugins.uninstalled': '插件已卸载',
  'plugins.uninstallFailed': '插件卸载失败',
  'plugins.system': '系统',
  'plugins.systemUninstallHint': '系统插件不可卸载',

  // Detail metadata
  'plugins.versionLabel': '版本',
  'plugins.digestLabel': '摘要',
  'plugins.digestCopied': '摘要已复制',
  'plugins.copyDigest': '复制摘要',
  'plugins.statusLabel': '状态',
  'plugins.stateLabel': '运行',

  // Detail sections
  'plugins.versions': '版本',
  'plugins.noVersions': '暂无版本信息',
  'plugins.skills': '包含技能',
  'plugins.noSkills': '此插件未包含任何技能。',
  'plugins.skillTryOut': '体验',
  'plugins.skillDetails': '详情',
  'plugins.permissions': '权限',
  'plugins.noPermissions': '暂无权限信息',
  'plugins.hooks': '钩子',
  'plugins.noHooks': '暂无钩子信息',

  // Configuration
  'plugins.configuration': '配置',
  'plugins.configJson': '配置 JSON',
  'plugins.secretBindings': '密钥绑定 JSON（仅支持 secret:// 引用）',
  'plugins.configSaved': '插件配置已保存',
  'plugins.configError': '配置必须为有效 JSON，密钥必须使用 secret:// 引用',
  'plugins.saveConfig': '保存配置',

  // ── Name translations for system plugins (keyed by plugin name) ──
  'plugins.name.source-transformations': '系统转换',
  'plugins.name.knowledge-research': '知识研究',
  'plugins.name.content-workflow': '内容工作流',
  'plugins.name.learning-assistant': '学习助手',
}

const cronPage = {
  'cron.title': '定时任务',
  'cron.subtitle': '管理智能体的自动和定时任务。',
  'cron.status.engine': '引擎状态',
  'cron.status.enabled': '已启用',
  'cron.status.disabled': '已禁用',
  'cron.status.totalJobs': '总任务数',
  'cron.status.nextWake': '下次唤醒',
  'cron.status.in': '{time}后',
  'cron.searchPlaceholder': '搜索任务...',
  'cron.refresh': '刷新',
  'cron.newJob': '新建任务',
  'cron.loadError.title': '加载定时任务失败',
  'cron.loadError.description': '从服务器获取定时任务列表时发生错误。',
  'cron.retry': '重试',
  'cron.empty.title': '未找到定时任务。',
  'cron.empty.description': '创建你的第一个定时任务以实现自动化。',
  'cron.empty.search': '未找到匹配的任务。',
  'cron.card.untitled': '无标题任务',
  'cron.card.schedule.cron': 'Cron: {expr}',
  'cron.card.schedule.every': '每 {seconds}秒',
  'cron.card.schedule.at': '在 {time}',
  'cron.card.schedule.unknown': '未知',
  'cron.card.status.unknown': '未知',
  'cron.card.action.edit': '编辑任务',
  'cron.card.action.duplicate': '复制',
  'cron.card.action.delete': '删除',
  'cron.card.target': '目标会话',
  'cron.card.lastRun': '上次运行',
  'cron.card.lastRun.never': '从不',
  'cron.card.nextRun': '下次运行',
  'cron.form.title.create': '创建定时任务',
  'cron.form.title.edit': '编辑定时任务',
  'cron.form.description': '配置此自动操作的计划和任务负载',
  'cron.form.tabs.basics': '基本与计划',
  'cron.form.tabs.execution': '执行目标',
  'cron.form.tabs.payload': '任务负载',
  'cron.form.name.label': '名称 *',
  'cron.form.name.placeholder': '例如：每日行情总结',
  'cron.form.desc.label': '描述',
  'cron.form.desc.placeholder': '这个任务是做什么的？',
  'cron.form.enabled': '启用任务',
  'cron.form.schedule.title': '计划配置',
  'cron.form.schedule.type': '类型',
  'cron.form.schedule.type.cron': 'Cron 表达式',
  'cron.form.schedule.type.every': '固定间隔 (毫秒)',
  'cron.form.schedule.type.at': '特定日期/时间',
  'cron.form.schedule.cronExpr': 'Cron 表达式',
  'cron.form.schedule.cronExpr.placeholder': '0 8 * * *',
  'cron.form.schedule.everyMs': '间隔 (毫秒)',
  'cron.form.execution.target': '目标会话',
  'cron.form.execution.target.main': '主会话 (默认智能体)',
  'cron.form.execution.target.isolated': '隔离 / 后台',
  'cron.form.execution.target.current': '当前界面会话',
  'cron.form.execution.desc': '决定后台任务将与哪个对话上下文交互。',
  'cron.form.payload.type': '负载类型',
  'cron.form.payload.type.agentTurn': '智能体对话 (发送提示词)',
  'cron.form.payload.type.systemEvent': '系统事件 (不可见)',
  'cron.form.payload.text.agentTurn': '提示词文本',
  'cron.form.payload.text.systemEvent': '事件数据',
  'cron.form.payload.placeholder.agentTurn': '例如：生成昨天的警报摘要...',
  'cron.form.payload.placeholder.systemEvent': 'JSON 或纯文本...',
  'cron.form.actions.cancel': '取消',
  'cron.form.actions.saving': '保存中...',
  'cron.form.actions.save': '保存任务'
}

const agentsPage = {
  'agents.title': '智能体',
  'agents.tree.title': '组织架构',
  'agents.tree.expand_all': '展开全部',
  'agents.tree.collapse_all': '收起全部',
  'agents.tree.search_placeholder': '搜索智能体...',
  'agents.tree.empty': '没有找到匹配的智能体',
  'agents.tree.total_agents': '共 {count} 个智能体',
  'agents.welcome.title': '选择一个智能体查看详情',
  'agents.welcome.description': '从左侧组织架构树中选择一个智能体，查看其仪表盘、指令、配置和技能信息。',
  'agents.welcome.view_ceo_dashboard': '查看 {name} 的仪表盘',
  'agents.detail.not_found': '智能体未找到',
  'agents.detail.not_found_desc': '所请求的智能体不存在或已被移除。',
  'agents.detail.back': '返回列表',
  'agents.detail.back_to_list': '返回智能体列表',
  'agents.detail.tab.dashboard': '仪表盘',
  'agents.detail.tab.instructions': '指令',
  'agents.detail.tab.configuration': '配置',
  'agents.detail.tab.skills': '技能',
  'agents.dashboard.total_runs': '总运行次数',
  'agents.dashboard.completed': '已完成 {count}',
  'agents.dashboard.success_rate': '成功率',
  'agents.dashboard.active_tasks_count': '{count} 个活跃任务',
  'agents.dashboard.avg_response_time': '平均响应时间',
  'agents.dashboard.total_cost': '总费用',
  'agents.dashboard.adapter': '适配器',
  'agents.dashboard.run_activity': '运行活跃度（近14天）',
  'agents.dashboard.success_history': '成功率趋势（近7天）',
  'agents.dashboard.recent_runs': '最近运行记录',
  'agents.dashboard.recent_tasks': '最近任务',
  'agents.dashboard.cost_breakdown': '费用明细',
  'agents.dashboard.input_tokens': '输入 Token',
  'agents.dashboard.output_tokens': '输出 Token',
  'agents.dashboard.cached_tokens': '缓存 Token',
  'agents.instructions.title': '智能体指令',
  'agents.instructions.identity': '身份信息',
  'agents.instructions.name': '名称',
  'agents.instructions.role': '职位',
  'agents.instructions.status': '状态',
  'agents.instructions.reports_to': '汇报对象',
  'agents.instructions.capabilities': '能力',
  'agents.configuration.adapter_settings': '适配器设置',
  'agents.configuration.adapter_type': '适配器类型',
  'agents.configuration.model': '模型',
  'agents.configuration.temperature': '温度',
  'agents.configuration.max_tokens': '最大 Token 数',
  'agents.configuration.context_window': '上下文窗口',
  'agents.configuration.system_prompt': '系统提示词',
  'agents.configuration.features': '功能特性',
}

const creationPromptsVariables = {
  'creation.prompt.var.target_platform': '目标平台',
  'creation.prompt.var.output_language': '输出语言',
  'creation.prompt.var.image_aspect_ratio': '主图比例',
  'creation.prompt.var.creation_mode': '创作模式',
  'creation.prompt.var.user_requirements': '用户要求',
  'creation.prompt.var.layout_structure': '套图结构',
  'creation.prompt.var.smart_total_count': '主图数量',
  'creation.prompt.var.custom_white_bg': '白底图',
  'creation.prompt.var.custom_scene': '场景图',
  'creation.prompt.var.custom_selling_point': '卖点图',
  'creation.prompt.var.custom_other': '其他图',
  'creation.prompt.var.product_name': '商品名称',
  'creation.prompt.var.detail_focus': '细节焦点',
  'creation.prompt.var.material': '材质',
  'creation.prompt.var.style': '视觉风格',
  'creation.prompt.var.ratio': '画幅比例',
  'creation.prompt.var.refine_instruction': '精修要求',
  'creation.prompt.var.usage': '目标用途',
  'creation.prompt.var.background_instruction': '背景处理',
  'creation.prompt.var.target_resolution': '输出分辨率',
  'creation.prompt.var.clothing_description': '服装描述',
  'creation.prompt.var.model_description': '模特特征',
  'creation.prompt.var.scene': '场景',
  'creation.prompt.var.pose': '姿势要求',
  'creation.prompt.var.set_name': '套装名称',
  'creation.prompt.var.top_description': '上装描述',
  'creation.prompt.var.bottom_description': '下装描述',
  'creation.prompt.var.accessories': '配饰',
  'creation.prompt.var.views': '展示角度',
  'creation.prompt.var.variant_type': '变体类型',
  'creation.prompt.var.variant_count': '变体数量',
  'creation.prompt.var.variant_descriptions': '变体描述',
  'creation.prompt.var.reference_elements': '参考元素',
  'creation.prompt.var.unique_features': '差异化特征',
  'creation.prompt.var.note_theme': '笔记主题',
  'creation.prompt.var.vibe': '风格定位',
  'creation.prompt.var.extra_requirements': '额外要求',
  'creation.prompt.var.highlights': '展示重点',
  'creation.prompt.var.camera_movement': '镜头运动',
  'creation.prompt.var.bgm_style': '背景音乐',
  'creation.prompt.var.product_description': '商品描述',
  'creation.prompt.var.scene_type': '场景类型',
  'creation.prompt.var.scene_description': '场景描述',
  'creation.prompt.var.atmosphere': '使用氛围',
  'creation.prompt.var.topic': '视频主题',
  'creation.prompt.var.description': '视频描述',
  'creation.prompt.var.camera_language': '镜头语言',
  'creation.prompt.var.extra_constraints': '额外约束',
  'creation.prompt.var.total_duration': '总时长',
  'creation.prompt.var.shot_count': '镜头数量',
  'creation.prompt.var.storyboard': '分镜头',
  'creation.prompt.var.shot_duration': '镜头时长',
  'creation.prompt.var.action_summary': '动作描述',
  'creation.prompt.var.video_type': '视频类型',
  'creation.prompt.var.target_duration': '目标时长',
  'creation.prompt.var.target_audience': '目标受众',
  'creation.prompt.var.key_message': '核心信息',
  'creation.prompt.var.hook_duration': '开场时长',
  'creation.prompt.var.max_shots': '最大镜头数',
  'creation.prompt.var.target_style': '目标风格',
  'creation.prompt.var.original_description': '原视频描述',
  'creation.prompt.var.style_reference': '风格参考',
  'creation.prompt.var.preserve_elements': '保留元素',
  'creation.prompt.var.style_strength': '风格强度',
  'creation.prompt.var.platform_adaptation': '平台适配策略',
  'creation.prompt.var.gen_type_desc': '生成类型配置说明',
  'creation.prompt.var.gen_total_count': '组图总张数参考',
  'creation.prompt.var.front_back_desc': '正背面要求',
  'creation.prompt.var.detail_count': '详情套图数量',
  'creation.prompt.var.detail_optimizations': '详情优化项',
  'creation.prompt.var.detail_ratio': '详情套图比例',
  'creation.prompt.var.resolution': '分辨率',
  'creation.prompt.var.product_count': '商品数量',
  'creation.prompt.var.reference_count': '参考图数量',
  'creation.prompt.var.replicate_level': '复刻程度',
  'creation.prompt.var.model_details': '模特补充细节',
  'creation.prompt.var.refine_optimizations': '精修优化项',
  'creation.prompt.var.duration': '视频时长',
  'creation.prompt.var.enable_voice_text': '配音要求',
  'creation.prompt.var.enable_watermark_text': '水印要求',
  'creation.prompt.var.video_mode_label': '生成模式',
  'creation.prompt.var.video_resolution': '目标分辨率',
  'creation.prompt.var.watermark_text': '水印文字',
  'creation.prompt.numVariables': '{count} 个变量',
}

const creationPromptsPage = {
  'creation.prompts.page.title': '提示词模板',
  'creation.prompts.page.description': '管理创作模块各场景的提示词模板。上传商品原图并填写变量值后，点击「测试生成」即可让多模态 LLM 生成每张主图的完整提示词。',
  'creation.prompts.page.loading': '正在加载模板...',
  'creation.prompts.page.loadError': '模板加载失败',
  'creation.prompts.page.retry': '重试',
  'creation.prompts.sidebar.category': 'CATEGORY',
  'creation.prompts.sidebar.templateCategories': '模板分类',
  'creation.prompts.sidebar.inheritance': '模板继承',
  'creation.prompts.sidebar.inheritanceDesc': '每个分类仅有一个生效模板。修改后即成为自定义版本；恢复默认可还原为系统内置模板。',
  'creation.prompts.list.search': '搜索模板',
  'creation.prompts.list.customized': '已自定义',
  'creation.prompts.list.default': '系统默认',
  'creation.prompts.list.empty': '没有匹配的模板',
  'creation.prompts.editor.copy': '复制正文',
  'creation.prompts.editor.restoring': '恢复中...',
  'creation.prompts.editor.restore': '恢复默认',
  'creation.prompts.editor.edit': '编辑',
  'creation.prompts.editor.editing': '编辑中...',
  'creation.prompts.editor.label': '模板正文',
  'creation.prompts.editor.placeholder': '请输入 Jinja2 提示词模板...',
  'creation.prompts.variables.title': '测试变量值',
  'creation.prompts.variables.selectPlaceholder': '选择 {label}',
  'creation.prompts.variables.inputPlaceholder': '输入 {label} 的测试值',
  'creation.prompts.variables.empty': '当前模板没有变量。',
  'creation.prompts.functionTool.title': 'Function Calling Schema',
  'creation.prompts.functionTool.description': '该提示词模板对应的 LLM function calling 工具定义。模型将强制调用此工具返回结构化输出。',
  'creation.prompts.images.title': '商品原图',
  'creation.prompts.images.description': '上传 1~3 张商品图，用于 LLM 视觉识别和主图提示词生成',
  'creation.prompts.images.empty': '尚未选择商品原图',
  'creation.prompts.preview.title': '后端渲染预览',
  'creation.prompts.preview.description': '使用沙箱模板引擎校验语法并替换测试变量。',
  'creation.prompts.preview.validating': '校验中...',
  'creation.prompts.preview.render': '渲染并校验',
  'creation.prompts.preview.placeholder': '填写测试变量后点击"渲染并校验"。',
  'creation.prompts.warning.title': '未配置多模态工具模型',
  'creation.prompts.warning.description': '多模态工具模型是 function calling 的执行引擎，用于将渲染后的提示词模板 + 商品原图发送给多模态 LLM，生成结构化的主图提示词。该模型需要同时具备<strong>图片理解（vision）</strong>和<strong>结构化输出（function calling）</strong>能力。',
  'creation.prompts.warning.goToModels': '前往模型设置',
  'creation.prompts.warning.modelReference': '推荐模型参考',
  'creation.prompts.generate.title': '多模态 LLM 生成',
  'creation.prompts.generate.description': '将渲染后的提示词模板 + 上传的商品原图发送给视觉 LLM，通过 function calling 生成每张主图的 title 和 prompt。',
  'creation.prompts.generate.generating': '生成中...',
  'creation.prompts.generate.test': '测试生成',
  'creation.prompts.generate.modelUsed': '使用模型：',
  'creation.prompts.generate.mainImage': '主图{idx}：{title}',
  'creation.prompts.generate.copySuccess': '主图{idx} 的提示词已复制',
  'creation.prompts.history.title': '版本历史',
  'creation.prompts.history.count': '共 {count} 个版本',
  'creation.prompts.history.empty': '暂无版本记录',
  'creation.prompts.meta.category': '内部分类',
  'creation.prompts.meta.variables': '变量数量',
  'creation.prompts.meta.status': '状态',
  'creation.prompts.meta.customized': '已自定义',
  'creation.prompts.meta.default': '系统默认',
  'creation.prompts.restoreDialog.title': '恢复默认模板',
  'creation.prompts.restoreDialog.description': '确认恢复为系统默认模板？当前自定义内容将被覆盖。',
  'creation.prompts.restoreDialog.confirm': '恢复默认',
  'creation.prompts.recommendations.internationalTitle': '国际模型',
  'creation.prompts.recommendations.internationalDesc': '以下模型系列均同时支持多模态视觉理解和 Function Calling，可直接用作多模态工具模型。',
  'creation.prompts.recommendations.chineseTitle': '国内模型',
  'creation.prompts.recommendations.chineseDesc': '以下国产模型系列同时具备视觉理解和 Function Calling 能力。',
  'creation.prompts.recommendations.footer': '以上版本为截至 2026 年 7 月的已知最新信息，实际可用版本以各平台官方文档为准。配置后，点击「测试生成」即可验证所选模型是否同时具备视觉和 Function Calling 能力。',
  'creation.prompts.toast.saved': '模板 v{version} 已保存',
  'creation.prompts.toast.saveFailed': '模板保存失败；模板可能已在其他窗口更新',
  'creation.prompts.toast.validateError': '模板语法或变量校验失败',
  'creation.prompts.toast.validatePass': '模板校验通过',
  'creation.prompts.toast.renderFailed': '模板渲染失败，请检查变量和语法',
  'creation.prompts.toast.restored': '已恢复为系统默认模板',
  'creation.prompts.toast.restoreFailed': '恢复默认模板失败',
  'creation.prompts.toast.selectTemplate': '请先选择一个模板',
  'creation.prompts.toast.selectImages': '请至少选择 1 张商品原图',
  'creation.prompts.toast.generated': '已生成 {count} 张主图提示词',
  'creation.prompts.toast.noResult': '模型未返回主图结果',
  'creation.prompts.toast.generateFailed': '生成失败',
  'creation.prompts.toast.copyContent': '模板内容已复制',
  'creation.prompts.group.ecommerce': '电商商品',
  'creation.prompts.group.video': '视频生成',
}

const creationPipelineZh = {
  'pipeline.step.analyze_product': '生成提示词',
  'pipeline.step.generate_images': '开始创建图片',
  'pipeline.step.generate_video': '生成视频',
  'pipeline.step.generate': '主图生成 #{n}',
  'pipeline.step.collect_results': '汇总结果',
  'pipeline.step.start': '初始化',
  'pipeline.status.pending': '等待中',
  'pipeline.status.queued': '已排队',
  'pipeline.status.running': '执行中',
  'pipeline.status.succeeded': '已完成',
  'pipeline.status.partially_succeeded': '部分成功',
  'pipeline.status.failed': '失败',
  'pipeline.status.canceled': '已取消',
  'pipeline.card.step': '步骤: {step}',
  'pipeline.statusCard.title': '执行进度',
  'pipeline.statusCard.current_step': '当前步骤: {step}',
  'pipeline.params.title': '任务参数',
  'pipeline.params.hint': '点击任务时自动展示该次生成的配置',
  'pipeline.params.empty': '暂无参数信息',
  'pipeline.params.prompt': '提示词',
  'pipeline.params.platform': '平台',
  'pipeline.params.language': '语言',
  'pipeline.params.mode': '模式',
  'pipeline.params.model': '模型',
  'pipeline.params.main_image_count': '主图数量',
  'pipeline.params.structure_mode': '套图结构',
  'pipeline.params.white_background_count': '白底图',
  'pipeline.params.scene_image_count': '场景图',
  'pipeline.params.selling_point_count': '卖点图',
  'pipeline.params.other_image_count': '其他图',
  'pipeline.params.aspect_ratio': '画面比例',
  'pipeline.params.resolution': '分辨率',
  'pipeline.params.detail_image_count': '详情套图数量',
  'pipeline.params.detail_ratio': '详情套图比例',
  'pipeline.params.detail_ratio.aplus_web': '高级A+（Web端）',
  'pipeline.params.detail_ratio.aplus_mobile': '高级A+（移动端）',
  'pipeline.params.detail_ratio.aplus_standard': '普通A+',
  'pipeline.params.detail_ratio.1:1': '1:1',
  'pipeline.params.detail_ratio.3:4': '3:4',
  'pipeline.params.detail_ratio.4:3': '4:3',
  'pipeline.params.detail_ratio.9:16': '9:16',
  'pipeline.params.detail_ratio.16:9': '16:9',
  'pipeline.params.detail_optimization_items': '优化方向',
  'pipeline.params.detail_optimization.hero_visual': '首屏主视觉',
  'pipeline.params.detail_optimization.core_selling_point': '核心卖点图',
  'pipeline.params.detail_optimization.usage_scenario': '使用场景图',
  'pipeline.params.detail_optimization.multi_angle': '多角度图',
  'pipeline.params.detail_optimization.brand_story': '品牌故事图',
  'pipeline.params.detail_optimization.effect_comparison': '效果对比图',
  'pipeline.params.detail_optimization.craftsmanship': '工艺制作图',
  'pipeline.params.detail_optimization.size_guide': '尺寸尺码图',
  'pipeline.params.detail_optimization.specification': '规格/参数表',
  'pipeline.params.detail_optimization.accessories': '配件/赠品图',
  'pipeline.params.detail_optimization.series_showcase': '系列展示图',
  'pipeline.params.detail_optimization.ingredients': '商品成分图',
  'pipeline.params.detail_optimization.after_sales': '售后保障图',
  'pipeline.params.detail_optimization.usage_tips': '使用建议图',
  'pipeline.params.sku_names': 'SKU 列表',
  'pipeline.params.pairing_mode': '配对模式',
  'pipeline.params.structure_mode.smart': '智能匹配',
  'pipeline.params.structure_mode.custom': '自定义配置',
  'pipeline.params.product_images': '商品原图',
  'pipeline.params.reference_images': '参考素材',
  'pipeline.params.model_images': '模特图',
  'pipeline.params.image_count': '{n} 张',
  'pipeline.params.mode.commerce': '商品主图',
  'pipeline.params.mode.video': '视频复刻',
  'pipeline.params.mode.sku_set': 'SKU套装',
  'pipeline.params.mode.hit_replicate': '爆款复刻',
  'pipeline.params.mode.product_refine': '商品精修',
  'pipeline.params.mode.clothing_set': '服装组图',
  'pipeline.params.mode.model_wear': '模特穿戴',
  'pipeline.params.video_mode': '复刻模式',
  'pipeline.params.video_resolution': '视频分辨率',
  'pipeline.params.video_duration': '视频时长',
  'pipeline.params.enable_voice': '生成声音',
  'pipeline.params.enable_watermark': '添加水印',
  'pipeline.params.watermark_text': '水印文字',
  'pipeline.params.replicate_level': '复刻程度',
  'pipeline.params.refine_optimizations': '快捷优化项',
  'pipeline.params.gen_types': '生成类型',
  'pipeline.params.model_source': '模特来源',
  'pipeline.params.model_gender': '模特性别',
  'pipeline.params.model_age': '年龄段',
  'pipeline.params.model_ethnicity': '人种',
  'pipeline.params.model_body_type': '体型',
  'pipeline.params.model_details': '补充细节',
  'ecommerce.form.parameterConfig': '参数配置',
  'ecommerce.form.parameterHint': '按当前需求整理输出规格',
  'ecommerce.form.platform': '平台',
  'ecommerce.form.language': '语言',
  'ecommerce.form.detailCount': '详情套图数量',
  'ecommerce.form.detailRatio': '详情套图比例',
  'ecommerce.form.structureConfig': '套图结构配置',
  'ecommerce.form.structureSmart': '智能匹配',
  'ecommerce.form.structureCustom': '自定义配置',
  'ecommerce.form.structureSmartDesc': 'AI 智能分析商品图，匹配最佳 Listing 套图',
  'ecommerce.form.structureCustomDesc': '可自由调整各类型图片数量，至少选择 1 张',
  'ecommerce.form.mainImageCount': '主图数量',
  'ecommerce.form.mainImageCountDesc': '设置需要生成的主图总数，AI 将自动分配各类型图片',
  'ecommerce.form.quickOptimizations': '快捷优化项',
  'ecommerce.form.quickOptimizationsDesc': '选择常用优化方向，可多选',
  'ecommerce.form.productImages': '商品原图',
  'ecommerce.form.productImagesHint': '1-3张，建议包含正面、侧面与细节图',
  'ecommerce.form.notSelected': '尚未选择{title}',
  'ecommerce.form.count': '张',
  'ecommerce.form.white_bg': '白底图',
  'ecommerce.form.white_bgDesc': '白底主图，多角度显现商品细节。',
  'ecommerce.form.scene': '场景图',
  'ecommerce.form.sceneDesc': '展示商品的生活使用场景和人物搭配',
  'ecommerce.form.sellingPoint': '卖点图',
  'ecommerce.form.sellingPointDesc': '展示商品的核心卖点及细节特写',
  'ecommerce.form.other': '其他',
  'ecommerce.form.otherDesc': '对比图、尺寸图等，根据商品智能匹配',
  'ecommerce.form.currentMode': '当前模式',
  'ecommerce.form.reuseSuccess': '已复用任务参数和素材',
  'ecommerce.form.pointCost': '积分',
  'ecommerce.form.placeholder.sku': 'SKU {n}',
  'ecommerce.form.placeholder.material': '素材-{n}',
}

const videoDownloader = {
  'vd.sync.title': '同步浏览器 Cookie',
  'vd.sync.description': '将浏览器中已登录站点的 Cookie 同步到本地后端，用于视频下载器解析抖音 / B站 / 小红书 / TikTok 等平台。下载时 yt-dlp 会自动带上这些 Cookie。',
  'vd.sync.checking': '正在检测扩展...',
  'vd.sync.installed_success': '已推送 {count} 条',
  'vd.sync.synced': '已同步',
  'vd.sync.not_synced': '未同步',
  'vd.sync.button': '同步全部站点',
  'vd.sync.syncing': '同步中...',
  'vd.sync.not_installed_title': '尚未安装 Cookie 同步扩展',
  'vd.sync.not_installed_desc': '抖音等平台会拦截无头请求，需要浏览器扩展从真实浏览器读取 Cookie。请按以下步骤安装：',
  'vd.sync.step_1': '点击下方按钮打开 chrome://extensions',
  'vd.sync.step_2': '右上角开启「开发者模式」',
  'vd.sync.step_3': '点击「加载已解压的扩展程序」',
  'vd.sync.step_4': '选择项目目录 extensions/fishown-bridge',
  'vd.sync.open_ext': '打开扩展管理页',
  'vd.sync.retry': '我已安装，重试检测',
  'vd.sync.recheck': '重新检测扩展状态',
  'vd.sync.no_cookies': '浏览器中未找到该站点 Cookie（请先登录该站点）',
  'vd.sync.sync_failed': '同步失败',
  'vd.sync.missing_creds': '未检测到登录凭据，请先登录 FishOwn',
  'vd.sync.pair_title': '授权浏览器扩展',
  'vd.sync.pair_desc': '首次使用需要在本页授权浏览器扩展。授权后扩展将获得受限权限（仅 Cookie 同步、命令执行、浏览器工具），不持有你的完整登录凭据，可随时在下方吊销。',
  'vd.sync.pair_button': '一键授权',
  'vd.sync.pairing': '授权中...',
  'vd.sync.pair_done': '授权成功，扩展已自动连接',
  'vd.sync.pair_failed': '授权失败：{error}',
  'vd.sync.paired_title': '浏览器扩展已授权',
  'vd.sync.manage_title': '已授权的扩展',
  'vd.sync.revoke': '吊销',
  'vd.sync.revoked': '已吊销',
  'vd.sync.hint': '提示：部分站点（如小红书）可能需要登录后才能读取完整 Cookie。无需扩展时也可通过环境变量 VIDEO_DOWNLOADER_COOKIES_FILE 手动指定 cookies.txt。',
}

const bridgeConnection = {
  'bridge.title': '浏览器插件连接',
  'bridge.settings_title': '浏览器插件',
  'bridge.settings_desc': '连接 FishOwn Bridge 浏览器扩展，获取 Cookie 同步、页面内容发送与浏览器自动化能力。',
  'bridge.status_hint': '管理浏览器插件连接',
  'bridge.status_paired': '浏览器插件已连接',
  'bridge.status_not_paired': '插件待授权',
  'bridge.status_not_installed': '未安装浏览器插件',
  'bridge.status_checking': '检测中...',
  'bridge.paired_badge': '已连接',
  'bridge.local_only_title': '当前环境不支持浏览器插件',
  'bridge.local_only_desc': '浏览器插件（FishOwn Bridge）仅在通过本机访问（localhost）FishOwn 时可用。远程地址无法连接插件，请使用桌面版并通过本机地址打开。',
  'bridge.checking': '正在检测浏览器插件...',
  'bridge.install_title': '尚未安装 FishOwn Bridge 扩展',
  'bridge.install_desc': '安装浏览器扩展后，即可在本页一键授权连接，获得 Cookie 同步、页面内容发送与浏览器自动化能力。请按以下步骤安装：',
  'bridge.install.step_1': '点击下方按钮打开 chrome://extensions',
  'bridge.install.step_2': '右上角开启「开发者模式」',
  'bridge.install.step_3': '点击「加载已解压的扩展程序」',
  'bridge.install.step_4': '选择项目目录 extensions/fishown-bridge',
  'bridge.open_ext': '打开扩展管理页',
  'bridge.retry': '我已安装，重试检测',
  'bridge.recheck': '重新检测扩展状态',
  'bridge.pair_title': '授权浏览器扩展',
  'bridge.pair_desc': '首次使用需要在本页授权浏览器扩展。授权后扩展将获得受限权限（仅 Cookie 同步、命令执行、浏览器工具），不持有你的完整登录凭据，可随时在下方吊销。',
  'bridge.pair_button': '一键授权',
  'bridge.pairing': '授权中...',
  'bridge.paired_title': '浏览器扩展已连接',
  'bridge.open_cookie_sync': '同步浏览器 Cookie',
  'bridge.manage_title': '已授权的扩展',
  'bridge.revoke': '吊销',
  'bridge.revoked': '已吊销',
}

const materials = {
  'materials.dir_type.ROOT': '全部',
  'materials.dir_type.SYSTEM': '系统',
  'materials.dir_type.USER': '我的',
  'materials.dir_type.NO_GROUP': '未分组',
}

export const zhTranslations: Record<string, string> = {
  ...navigation,
  ...controls,
  ...user,
  ...settingsLanguage,
  ...settingsActions,
  ...settingsCommon,
  ...settingsContentProcessing,
  ...settingsEmbedding,
  ...settingsFiles,
  ...notebooksPage,
  ...notebooksList,
  ...notebooksCard,
  ...notebooksHeader,
  ...notebooksDetail,
  ...notebooksKnowledgeGraph,
  ...notebooksSources,
  ...notebooksUpload,
  ...notebooksNotes,
  ...notebooksChat,
  ...notebooksEditor,
  ...notebookAssociations,
  ...commonCommandPalette,
  ...commonAddButton,
  ...commonTheme,
  ...commonActions,
  ...commonConfirmDialog,
  ...commonErrorBoundary,
  ...commonConnection,
  ...commonModelSelector,
  ...modelSelectorDialog,
  ...commonContextToggle,
  ...commonContextIndicator,
  ...searchPage,
  ...sourcesPage,
  ...auth,
  ...bananaproPage,
  ...imageGeneratorPage,
  ...videoGeneratorPage,
  ...addSourceDialog,
  ...addExistingSourceDialog,
  ...createNotebookDialog,
  ...collapsibleColumn,
  ...modelsPage,
  ...providerStatus,
  ...providerSettings,
  ...modelTypeSection,
  ...modelPricing,
  ...defaultModelsSection,
  ...addModelForm,
  ...embeddingModelChangeDialog,
  ...digitalEmployeesPage,
  ...marketplacePage,
  ...workflowsPage,
  ...advancedPage,
  ...sourceCard,
  ...sourceDetail,
  ...streamingResponse,
  ...advancedModelsDialog,
  ...saveToNotebooksDialog,
  ...modelsToast,
  ...xhsqunToast,
  ...dykolToast,
  ...xhsqunPrivateToast,
  ...emailTemplateToast,
  ...emailRenewToast,
  ...gnkeyToast,
  ...emailCustomerToast,
  ...emailTaskToast,
  ...workflowsToast,
  ...gzhkolMonitorToast,
  ...gzhkolResourceToast,
  ...dykolTask,
  ...notebooksToast,
  ...emailTaskPage,
  ...notesToast,
  ...searchToast,
  ...settingsToast,
  ...sourcesToast,
  ...versionCheckToast,
  ...chatToast,
  ...commonToast,
  ...skillsPage,
  ...pluginsPage,
  ...cronPage,
  ...agentsPage,
  ...creationPromptsPage,
  ...creationPromptsVariables,
  ...creationPipelineZh,
  ...videoDownloader,
  ...bridgeConnection,
  ...materials,
}
